import { BrokerSample } from "./broker";
import { getConfig } from "./config/config";
import Datafeed from "./datafeed";
import loggly_util from "../src/loggly-util";
import { AlterUrlParam, captureEvent, changeURLparam, checkingLayoutType, getExch_Exchtype_Scripcode, getPreferenceApi, getSellAuthStatus, setPreferenceApi, observeTabChanges, saveMW, findMissingValues, openCustomAlert, sortPreviousSymbols, filterIsEditable, getCookie, deleteThemeCookieAndSetNewCookie, parseChartUrl, bringToFront, updateMainSeries, decryptAES, getExactParam } from "./helpers";
import { getExchangeName } from "./commonMethods/comFunctions";
import { getDefault, getDefaultSymbolNames } from "./Services/watchListApiCall";
import { checkLoginTradestation } from "./singlelogin/loginUtil";
import { widget } from "/charting_library_clonned_data/charting_library";
import { handleMessageEvent } from "./orderDialogue";
import util from "./util";
import { THEME_COOKIE } from "./utils/constant";
import { checkConnectionStatus, showMessage } from "./Services/alertNotification";
import { getScripInfoData } from "./Services/scripInfo";
import { openMarketDepthDropDown } from "./Services/MarketDepth/openiMarketDepthDailog";
import { onFocusChange } from "./utils/websocketwrapper";
import CWA2SigmaIndicator from "./CWA2Sigma";
import { fetchAndMergeIndicesOncePerDay, clearUserDataForCautionary } from "./Services/cautionaryHelper";
import AllCandlestickPatterns from "./AllCandlestickPatterns";
import { getAutoSavePrefData } from "./Services/AutoSaveApis/getAutoSaveApiCall";
import { postAutoSavePrefData } from "./Services/AutoSaveApis/postAutoSaveApiCall";
import { initProductsPopup, updateProductsPopupTheme } from "./Services/productDisplay";
import { InternalCWAUser, InternalLogglyUser } from "./firebase-config";
import { METHOD_FOR_CHART_SOCKET, SOCKET_SUBSCRIPTION_METHODS, } from "./utils/constant";
import { getOiProfileData } from "./Services/OiProfile/getOptionChainListApiCall";
import { OI_PROFILE_STORAGE_KEY, setOIProfileVisibility, updateOIProfileButton, createOiWebsocketUpdateHandler, createFetchOiDataForPane, initOIProfileCanvas, } from "./Services/OiProfile/oiProfileHelper";
import { subscribeToData, unsubscribeDataBySubscriber, } from "./utils/websocketwrapper";
const reqUrl = new URL(window.location);
if (reqUrl.searchParams.get("osName") !== "flutter") {
    await checkLoginTradestation(reqUrl);
}
sessionStorage.setItem("__cInternal", "false");
sessionStorage.setItem("__lInternal", "false");
await InternalCWAUser();
await InternalLogglyUser();
if (reqUrl.searchParams.get("osName") === "flutter") {
    let doubleDecryptedJWT;
    let clientCode = reqUrl.searchParams.get("ClientCode");
    let encJwtToken = getExactParam("cjqy");
    try {
        let DecryptedJWT = decryptAES(encJwtToken);
        doubleDecryptedJWT = decryptAES(DecryptedJWT);
    }
    catch (error) {
        console.error("Decryption failed:", error);
    }
    if (clientCode)
        localStorage.setItem("ClientCode", clientCode);
    if (doubleDecryptedJWT)
        localStorage.setItem("paramJwt", doubleDecryptedJWT);
}
const paramsForScripInfo = parseChartUrl(window.location.href);
let ScripInfoDetails;
try {
    ScripInfoDetails = await getScripInfoData(paramsForScripInfo);
}
catch (error) {
    console.error("Failed to fetch ScripInfoData:", error);
    ScripInfoDetails = null;
}
const browserName = util.getBrowserName();
let productVal, themeVal, defaultClose, preferences, preferenceData, brokerFac;
let prefChanged = false;
let defSet = false;
let user = localStorage.getItem("ClientCode");
let chartSetting_Tradechart;
let chartSetting_noTradechart;
let AutoSaveApiData;
window.clevertap.onUserLogin.push({
    Site: {
        Name: localStorage.getItem("ClientName"),
        Identity: user,
    },
});
(() => {
    const urlObject = new URL(window.location.href);
    const searchParams = urlObject.searchParams;
    if (searchParams.has("TrasactionStatus")) {
        return;
    }
    else {
        if (window.location.href.includes("failure") ||
            window.location.href.includes("success")) {
            const newurl = localStorage.getItem(localStorage.getItem("ClientCode") + "CDSL");
            const url = new URL(window.location.href);
            const params = new URLSearchParams(newurl);
            url.search = params.toString();
            const finalUrl = url.toString();
            window.location.href = finalUrl;
        }
    }
})();
const osName = reqUrl.searchParams.get("osName");
const isNewApp = reqUrl.searchParams.get("isNewApp");
if (sessionStorage.getItem("__cInternal") === "true") {
    try {
        let appType = "tv";
        if (osName === "flutter") {
            appType = isNewApp === "true" ? "newApp" : "oldApp";
        }
        AutoSaveApiData = await getAutoSavePrefData(appType);
    }
    catch (error) {
        console.error("Data is not present in preference API", error);
    }
}
try {
    preferenceData = await getPreferenceApi(user, reqUrl);
}
catch (error) {
    console.error("An error occurred while fetching preference data:", error);
}
let reqExch = getExchangeName(ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Exch);
let reqSymbol = reqExch +
    ":" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Name.trim()) +
    "/" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode) +
    "-" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ExchType);
export let checkTheme = () => {
    themeVal = getCookie(THEME_COOKIE);
    if (themeVal != undefined) {
        defSet = true;
        themeVal == "dark"
            ? document.body.classList.add("dark-theme")
            : document.body.classList.remove("dark-theme");
    }
    else {
        if (!preferenceData.ERR_MSG) {
            if (preferenceData.themeVal === "dark" ||
                preferenceData.themeVal === "Dark") {
                document.body.classList.add("dark-theme");
            }
            else {
                document.body.classList.remove("dark-theme");
            }
            themeVal = "dark";
        }
        else {
            defSet = true;
            themeVal = "light";
        }
    }
};
let checkProduct = () => {
    if (localStorage.getItem("productVal") &&
        localStorage.getItem("productVal") !== "undefined" &&
        localStorage.getItem("productVal") !== undefined) {
        productVal = localStorage.getItem("productVal");
    }
    else {
        if (!preferenceData.ERR_MSG) {
            localStorage.setItem("productVal", preferenceData.productVal);
            productVal = localStorage.getItem("productVal");
        }
        else {
            localStorage.setItem("productVal", "Delivery");
            productVal = "Delivery";
        }
    }
};
let checkClose = () => {
    if (localStorage.getItem("defaultClose") &&
        localStorage.getItem("defaultClose") !== "undefined" &&
        localStorage.getItem("defaultClose") !== undefined) {
        defaultClose = localStorage.getItem("defaultClose");
    }
    else {
        if (!preferenceData.ERR_MSG) {
            localStorage.setItem("defaultClose", preferenceData.defaultClose);
            defaultClose = localStorage.getItem("defaultClose");
        }
        else {
            localStorage.setItem("defaultClose", "Market");
            defaultClose = "Market";
        }
    }
};
try {
    const istradeChart = reqUrl.searchParams.get("isTradeChart");
    const osname = reqUrl.searchParams.get("osName");
    let ctName = osname === "flutter"
        ? "Mobile_Tradingview"
        : "Screen_Open";
    let ctPlatform;
    if (istradeChart === "true") {
        ctPlatform = "TvChart";
    }
    else if ((istradeChart === "false") && (osname === "flutter")) {
        ctPlatform = "Mobile";
    }
    else {
        ctPlatform = "ttweb/fno";
    }
    captureEvent(ctName, {
        ClientCode: localStorage.getItem("ClientCode"),
        Script_Name: reqSymbol,
        Action: "Onboarding_Chart_Screen",
        PlatForm: ctPlatform,
        Chart_Type_Selected: "Trading View"
    });
}
catch (error) {
    console.error(error);
}
preferences = {
    themeVal,
    productVal,
    defaultClose,
};
let checkPreferences = async () => {
    checkTheme();
    checkProduct();
    checkClose();
};
if (reqUrl.searchParams.get("isTradeChart") === "true") {
    checkPreferences();
}
else {
    if (reqUrl.searchParams.get("theme") === "light" ||
        reqUrl.searchParams.get("theme") === "day") {
        themeVal = "light";
        document.body.classList.remove("dark-theme");
    }
    else if (reqUrl.searchParams.get("theme") === "dark" ||
        reqUrl.searchParams.get("theme") === "night") {
        themeVal = "dark";
        document.body.classList.add("dark-theme");
    }
}
const prefix = "tradingview.savedwatch";
for (let key in localStorage) {
    if (key.startsWith(prefix)) {
        localStorage.removeItem(key);
    }
}
if (!reqUrl.searchParams.has("ispopOut")) {
    if (sessionStorage.getItem("WatchList_set") != null) {
        sessionStorage.removeItem("WatchList_set");
    }
}
console.log("TVNewChart TS-Version - V26.06.05");
loggly_util.checkLogglyInitialization();
const { APP_BASE_API_URL, APP_OCP_APIM_KEY, APP_HEAD_KEY, APP_BASE_SWARAJ_API_URL, APP_USER_ID, APP_PASSWORD, APP_BASE_CHARTSLAYOUT_API_URL } = getConfig();
let disabledfeatures = [
    "show_right_widgets_panel_by_default",
    "create_volume_indicator_by_default"
];
let enabled_features = [
    "custom_resolutions",
    "show_zoom_and_move_buttons_on_touch",
    "save_chart_properties_to_local_storage",
    "volume_force_overlay",
    "study_templates",
    "display_legend_on_all_charts",
    "dom_widget",
];
let data_window = true;
var interval = "1";
var content, c;
var chartContentFlag_Tradechart = false;
var chartContentFlag_noTradechart = false;
var userId = "Priti";
let iframe2;
localStorage.setItem("clientID", user);
let sessionScripCode = ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode;
const excludedOS = ["Android", "iOS", "flutter"];
if (reqUrl.searchParams.get("isTradeChart") === "false") {
    if (!excludedOS.includes(osName)) {
        disabledfeatures = [
            "charting_library_debug_mode",
            "add_to_watchlist",
            "open_account_manager",
            "multiple_watchlists",
            "show_trading_notifications_history",
            "trading_account_manager",
            "order_info",
            "watchlist_import_export",
            "watchlist_context_menu",
            "buy_sell_buttons",
            "header_fullscreen_button",
            "header_symbol_search",
            "header_compare",
            "chart_crosshair_menu",
            "chart_property_page_trading",
            "symbol_search_hot_key",
            "legend_inplace_edit",
            "order_panel",
            "show_right_widgets_panel_by_default",
            "right_toolbar",
            "prefer_symbol_name_over_fullname",
            "create_volume_indicator_by_default"
        ];
        enabled_features.push("hide_right_toolbar");
        enabled_features.push("hide_right_toolbar_tabs");
        data_window = false;
    }
    else if (isNewApp === "true") {
        disabledfeatures = [
            "show_right_widgets_panel_by_default",
            "create_volume_indicator_by_default",
            "symbol_search_hot_key",
            "show_right_widgets_panel_by_default",
            "trading_account_manager",
            "right_toolbar",
            "buy_sell_buttons",
            "header_symbol_search",
            "header_compare",
            "header_layouttoggle",
            "header_saveload",
            "header_fullscreen_button"
        ];
        enabled_features.push("hide_left_toolbar_by_default");
    }
    else {
        disabledfeatures = [
            "charting_library_debug_mode",
            "add_to_watchlist",
            "open_account_manager",
            "multiple_watchlists",
            "show_trading_notifications_history",
            "trading_account_manager",
            "order_info",
            "watchlist_import_export",
            "watchlist_context_menu",
            "buy_sell_buttons",
            "header_fullscreen_button",
            "header_symbol_search",
            "header_compare",
            "header_layouttoggle",
            "header_saveload",
            "chart_crosshair_menu",
            "chart_property_page_trading",
            "broker_button",
            "order_panel",
            "show_right_widgets_panel_by_default",
            "right_toolbar",
            "prefer_symbol_name_over_fullname",
            "create_volume_indicator_by_default",
            "header_layouttoggle",
            "header_saveload",
        ];
        // const isInternal = sessionStorage.getItem("__cInternal") === "true";
        // disabledfeatures = isInternal
        // 	? baseFeatures.filter(item => !["header_layouttoggle", "header_saveload"].includes(item))
        // 	: baseFeatures;
        enabled_features.push("hide_right_toolbar");
        enabled_features.push("hide_right_toolbar_tabs");
        data_window = false;
    }
}
const baseTimeFrameArr = [
    { text: "1d", resolution: "1", description: "1D", title: "1D" },
    { text: "5d", resolution: "15", description: "5D", title: "5D" },
    { text: "1m", resolution: "1D", description: "1M", title: "1M" },
    { text: "2m", resolution: "1D", description: "2M", title: "2M" },
    { text: "3m", resolution: "1D", description: "3M", title: "3M" },
];
let timeFrameArr;
if (excludedOS.includes(osName)) {
    if (["futures", "FUTURES", "OPTIONS", "options"].includes(ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.InstrumentType)) {
        timeFrameArr = baseTimeFrameArr; // Use base timeframes for futures/options
    }
    else {
        timeFrameArr = [
            ...baseTimeFrameArr,
            { text: "1y", resolution: "1D", description: "1Y", title: "1Y" },
            { text: "5y", resolution: "1W", description: "5Y", title: "5Y" },
            { text: "22y", resolution: "1M", description: "Max", title: "MAX" },
        ];
    }
}
else {
    timeFrameArr = [
        ...baseTimeFrameArr,
        { text: "1y", resolution: "1D", description: "1Y", title: "1Y" },
        { text: "5y", resolution: "1W", description: "5Y", title: "5Y" },
        { text: "22y", resolution: "1M", description: "Max", title: "MAX" },
    ];
}
if (reqUrl.searchParams.has("redirectionTv") &&
    reqUrl.searchParams.get("redirectionTv") == "true") {
    localStorage.removeItem("autoSaveStorage_Tradechart");
    var url = new URL(window.location);
    url.searchParams.delete("redirectionTv");
    window.history.pushState({}, "", url);
}
if (reqUrl.searchParams.has("ispopOut")) {
    disabledfeatures = [
        "charting_library_debug_mode",
        "add_to_watchlist",
        "open_account_manager",
        "multiple_watchlists",
        "show_trading_notifications_history",
        "trading_account_manager",
        "order_info",
        "watchlist_import_export",
        "watchlist_context_menu",
        "create_volume_indicator_by_default"
    ];
    data_window = false;
}
let paneIndex = sessionStorage.getItem("activeChartChanged_Tradechart") || 0;
if (reqUrl.searchParams.get("isTradeChart") === "false") {
    sessionStorage.setItem("LayoutType_noTradechart", "s");
    sessionStorage.setItem("activeChartChanged_noTradechart", "0");
    sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify([reqSymbol]));
    sessionStorage.setItem("reqSymbols_noTradechart", JSON.stringify([symbolAfterLoad]));
    if (localStorage.getItem("lastChartSaved_noTradechart")) {
        content = JSON.parse(JSON.parse(localStorage.getItem("lastChartSaved_Tradechart")).content);
        var content1 = JSON.parse(localStorage.getItem("lastChartSaved_Tradechart"));
        content = { ...content, extendedData: content1 };
    }
}
else {
    sessionStorage.setItem("LayoutType_Tradechart", "s");
    sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify([reqSymbol]));
    sessionStorage.setItem("activeChartChanged_Tradechart", "0");
}
if (reqUrl.searchParams.get("isTradeChart") === "false") {
    if (reqUrl.searchParams.get("searchFlag") === "true") {
        const autoSaveKey = "autoSaveStorage_noTradechart" + sessionScripCode;
        const autoSaveKeyreso = "reso" + sessionScripCode;
        if (!sessionStorage.getItem(autoSaveKey)) {
            sessionStorage.setItem(autoSaveKey, localStorage.getItem("autoSaveStorage_noTradechart"));
            sessionStorage.setItem(autoSaveKeyreso, localStorage.getItem("reso"));
        }
        chartSetting_noTradechart = sessionStorage.getItem("autoSaveStorage_noTradechart" + sessionScripCode);
    }
    else {
        chartSetting_noTradechart = JSON.parse(localStorage.getItem("autoSaveStorage_noTradechart"));
        if (chartSetting_noTradechart) {
            chartSetting_noTradechart.charts[0].panes.forEach((pane) => {
                if (pane.sources[0].type === "MainSeries") {
                    pane.sources[0].state.symbol = reqSymbol;
                    pane.sources[0].state.shortName = ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Name.trim();
                }
            });
            localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(chartSetting_noTradechart));
        }
    }
}
else {
    if (reqUrl.searchParams.get("isTradeChart") === "true") {
        if (reqUrl.searchParams.get("searchFlag") === "true") {
            const autoSaveKey = "autoSaveStorage_noTradechart" + sessionScripCode;
            const autoSaveKeyreso = "reso" + sessionScripCode;
            if (!sessionStorage.getItem(autoSaveKey)) {
                sessionStorage.setItem(autoSaveKey, localStorage.getItem("autoSaveStorage_noTradechart"));
                sessionStorage.setItem(autoSaveKeyreso, localStorage.getItem("reso"));
            }
            chartSetting_noTradechart = sessionStorage.getItem("autoSaveStorage_noTradechart" + sessionScripCode);
        }
    }
}
var symbolAfterLoad = reqExch +
    ":" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Name.trim()) +
    "/" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode) +
    "-" +
    (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ExchType);
let firstLoad = true;
if (reqUrl.searchParams.get("isTradeChart") === "true") {
    if (sessionStorage.getItem("isMultiLayOut_Tradechart") != null) {
        sessionStorage.removeItem("isMultiLayOut_Tradechart");
    }
    if (sessionStorage.getItem("chartContentFlag_Tradechart") == "true") {
        sessionStorage.setItem("chartContentFlag_Tradechart", "false");
    }
}
else {
    if (sessionStorage.getItem("isMultiLayOut_noTradechart") != null) {
        sessionStorage.removeItem("isMultiLayOut_noTradechart");
    }
    if (sessionStorage.getItem("chartContentFlag_noTradechart") == "true") {
        sessionStorage.setItem("chartContentFlag_noTradechart", "false");
    }
}
localStorage.setItem("reso", interval);
//function for option chain opening
function openingOptionChain() {
    //let iframe2;
    function Ifram(newDiv, dragstart) {
        const targetOrigin = reqUrl.hostname === "tv-pre.5paisa.com"
            ? "https://fno-pre.5paisa.com/oc-iframe?"
            : "https://fno.5paisa.com/oc-iframe?";
        var iframe = document.createElement("iframe");
        iframe.id = "myFrame";
        iframe.draggable = true;
        iframe.style.width = "100%";
        iframe.style.height = "95%";
        if (themeVal == "light") {
            iframe.style.border = "1px solid #6C94B836";
        }
        else {
            iframe.style.border = "1px solid #667085";
        }
        iframe.style.marginTop = "1.2%";
        // iframe.style.marginLeft = "-0.8%";
        iframe.style.borderRadius = "4px";
        newDiv.appendChild(iframe);
        iframe.addEventListener("dragstart", dragstart);
        var symbolRequired;
        var splitSymbol = window.tvWidget
            .activeChart()
            .symbol()
            .split(":")[1]
            .split("/")[0];
        const splitSymbolArr = splitSymbol.split(" ");
        if (splitSymbol.includes("BSE BANKEX")) {
            symbolRequired = splitSymbolArr[1];
        }
        else {
            symbolRequired = splitSymbolArr[0] || splitSymbol;
        }
        const FnoData = getExch_Exchtype_Scripcode(window.tvWidget.activeChart().symbol());
        const params = {
            theme: themeVal,
            symbol: symbolRequired,
            metrics: sessionStorage.getItem("PriceGreek") === null
                ? "Price"
                : sessionStorage.getItem("PriceGreek"),
            exch: FnoData.Exch,
            exchtype: FnoData.ExchType,
        };
        var queryString = Object.keys(params)
            .map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        })
            .join("&");
        var iframeSrc = targetOrigin + queryString;
        iframe.src = iframeSrc;
        return iframe;
    }
    {
        //icon for close button
        var icon = document.createElement("img");
        icon.src = "https://images.5paisa.com/SPOT/chart/deleteIconOptionChain.svg";
        icon.alt = "Icon";
        icon.style.marginRight = "-1px";
        var buttonContainer = document.createElement("div");
        var optionchainTextContainer = document.createElement("div");
        var dropDownContainer = document.createElement("div");
        var dropDownSubContainer = document.createElement("div");
        dropDownContainer.appendChild(dropDownSubContainer);
        var dropDownOptionsContainer = document.createElement("div");
        dropDownOptionsContainer.style.border = "1px solid #E0E1EB";
        dropDownOptionsContainer.style.borderRadius = "4px";
        dropDownSubContainer.appendChild(dropDownOptionsContainer);
        dropDownOptionsContainer.style.position = "absolute";
        dropDownOptionsContainer.style.overflowY = "auto";
        dropDownOptionsContainer.style.backgroundColor = "#fff";
        dropDownOptionsContainer.style.boxShadow = "0 1px 4px #6c94b84d";
        dropDownOptionsContainer.style.marginTop = "30px";
        dropDownOptionsContainer.style.maxHeight = "200px";
        dropDownOptionsContainer.style.width = "82px";
        //dropDownOptionsContainer.style.marginLeft = "-5px";
        dropDownOptionsContainer.style.zIndex = "1";
        dropDownOptionsContainer.style.display = "none";
        dropDownContainer.addEventListener("click", (event) => {
            event.stopPropagation();
            if (dropDownOptionsContainer.style.display == "none") {
                dropDownOptionsContainer.style.display = "block";
            }
            else {
                dropDownOptionsContainer.style.display = "none";
            }
        });
        var span_price_div = document.createElement("div");
        span_price_div.id = "span_price_div";
        var span_greek_div = document.createElement("div");
        span_greek_div.id = "span_greek_div";
        span_price_div.style.padding = "5px 10px";
        span_greek_div.style.padding = "5px 10px";
        var span_price = document.createElement("SPAN");
        span_price.innerHTML = "Price";
        span_price.style.color = " #55586A";
        span_price.style.fontSize = "12px";
        span_price.style.fontWeight = "300";
        span_price.style.fontFamily = "Roboto";
        span_price_div.appendChild(span_price);
        var span_greek = document.createElement("SPAN");
        span_greek.innerHTML = "Greeks";
        span_greek.style.color = " #55586A";
        span_greek.style.fontSize = "12px";
        span_greek.style.fontWeight = "300";
        span_greek.style.fontFamily = "Roboto";
        span_greek_div.appendChild(span_greek);
        dropDownOptionsContainer.appendChild(span_price_div);
        const greekControllerParams = getExch_Exchtype_Scripcode(window.tvWidget.activeChart().symbol());
        const symbolsToCheck = [
            "SENSEX",
            "sensex",
            "SENSEX50",
            "sensex50",
            "BANKEX",
            "bankex",
        ];
        const exchangeToCheck = "M";
        if (!(symbolsToCheck.includes(greekControllerParams.symbol.trim()) ||
            (greekControllerParams === null || greekControllerParams === void 0 ? void 0 : greekControllerParams.Exch) === exchangeToCheck)) {
            dropDownOptionsContainer.appendChild(span_greek_div);
        }
        var span_tag = document.createElement("span");
        span_tag.id = "span_tag_PG";
        dropDownSubContainer.appendChild(span_tag);
        span_tag.style.color = " #55586A";
        span_tag.style.fontWeight = "300";
        span_tag.style.fontSize = "12px";
        span_tag.style.marginLeft = "8px";
        span_tag.style.fontFamily = "Roboto";
        var imgtag = document.createElement("img");
        imgtag.src =
            "	https://commondatastorage.googleapis.com/images.5paisa.com/fno/assets/svgs/dropdown.svg";
        dropDownSubContainer.appendChild(imgtag);
        span_price_div.addEventListener("mouseover", function () {
            if (themeVal == "light") {
                span_price_div.style.backgroundColor = "#e1eaf6";
            }
            else {
                span_price_div.style.backgroundColor = "#344054";
            }
        });
        span_price_div.addEventListener("mouseout", function () {
            span_price_div.style.backgroundColor = "";
        });
        span_greek_div.addEventListener("mouseover", function () {
            if (themeVal == "light") {
                span_greek_div.style.backgroundColor = "#e1eaf6";
            }
            else {
                span_greek_div.style.backgroundColor = "#344054";
            }
        });
        span_greek_div.addEventListener("mouseout", function () {
            span_greek_div.style.backgroundColor = "";
        });
        span_price_div.addEventListener("click", function () {
            if (span_tag.innerHTML != "Price") {
                span_tag.innerHTML = "Price";
                imgtag.style.marginLeft = "25px";
                sessionStorage.setItem("PriceGreek", "Price");
            }
            let iframeForPostMsg = document.getElementById("myFrame");
            var iframeOrigin = new URL(iframeForPostMsg.src).origin;
            console.table(iframeOrigin, "Price");
            iframeForPostMsg.contentWindow.postMessage({ type: "Price" }, iframeOrigin);
        });
        span_greek_div.addEventListener("click", () => {
            if (span_tag.innerHTML != "Greeks") {
                span_tag.innerHTML = "Greeks";
                imgtag.style.marginLeft = "20px";
                sessionStorage.setItem("PriceGreek", "Greeks");
            }
            let iframeForPostMsg = document.getElementById("myFrame");
            var iframeOrigin = new URL(iframeForPostMsg.src).origin;
            console.table(iframeOrigin, "Greeks");
            iframeForPostMsg.contentWindow.postMessage({ type: "Greeks" }, iframeOrigin);
        });
        dropDownContainer.style.marginRight = "30px";
        dropDownContainer.style.marginLeft = "auto";
        dropDownContainer.style.marginTop = "-25px";
        if (themeVal == "light") {
            dropDownContainer.style.border = "1px solid #E0E1EB";
        }
        else {
            dropDownContainer.style.border = "1px solid #475467";
            span_tag.style.color = "#F9FAFB";
        }
        dropDownContainer.style.borderRadius = "4px";
        dropDownContainer.style.height = "24px";
        dropDownContainer.style.width = "82px";
        dropDownSubContainer.style.height = "13px";
        dropDownSubContainer.style.width = "82px";
        dropDownSubContainer.style.marginTop = "4px";
        dropDownSubContainer.style.alignContent = "center";
        imgtag.style.marginLeft = "20px";
        var myDiv = document.createElement("div");
        myDiv.style.position = "absolute";
        myDiv.style.display = "none";
        myDiv.style.width = "95%";
        myDiv.style.height = "98%";
        myDiv.style.marginLeft = "2%";
        myDiv.style.zIndex = "1";
        //myDiv.style.border = "1px solid black";
        var newDiv = document.createElement("ul");
        newDiv.id = "myFrameDiv";
        newDiv.style.position = "absolute";
        newDiv.style.width = "917px";
        newDiv.style.height = `${window.innerHeight - 200}px`;
        newDiv.style.top = "15%";
        newDiv.style.left = "15%";
        newDiv.style.zIndex = "999";
        newDiv.draggable = true;
        newDiv.style.padding = "20px";
        newDiv.style.border = "1px solid #6C94B836";
        newDiv.style.borderRadius = "4px";
        newDiv.style.boxShadow = " 0px -2px 6px 0px #6C94B81F";
        if (themeVal == "light") {
            newDiv.style.backgroundColor = "#FFFFFF";
            icon.src =
                "https://images.5paisa.com/SPOT/chart/deleteIconOptionChain.svg";
            icon.style.width = "20px"; //"#475467";
        }
        else {
            newDiv.style.backgroundColor = "#101828";
            icon.src =
                "https://images.5paisa.com/SPOT/chart/dark-deleteIconOptionChain.svg";
            icon.style.width = "20px";
            dropDownOptionsContainer.style.backgroundColor = "#1e2631";
            dropDownOptionsContainer.style.border = "1px solid #344054";
            span_price.style.color = "#dbdfe7";
            span_greek.style.color = "#dbdfe7";
        }
        newDiv.addEventListener("dragstart", drag_start);
        newDiv.appendChild(buttonContainer);
        newDiv.appendChild(optionchainTextContainer);
        newDiv.appendChild(dropDownContainer);
        iframe2 = Ifram(newDiv, drag_start);
        var parentDiv = document.getElementById("tv_chart_container");
        var existingIframe = parentDiv.childNodes[0];
        parentDiv.insertBefore(newDiv, existingIframe);
        parentDiv.insertBefore(myDiv, existingIframe);
        //option chain text
        var optionChainHeadingSpan = document.createElement("SPAN");
        optionchainTextContainer.appendChild(optionChainHeadingSpan);
        optionChainHeadingSpan.innerHTML = "OPTION CHAIN";
        optionChainHeadingSpan.style.color = "#0080FF";
        optionChainHeadingSpan.style.fontWeight = "300";
        optionChainHeadingSpan.style.fontFamily = "Roboto";
        optionchainTextContainer.style.width = "150px";
        optionchainTextContainer.style.height = "22px";
        optionchainTextContainer.style.zIndex = "999";
        optionchainTextContainer.style.left = "-2px";
        if (!(symbolsToCheck.includes(greekControllerParams.symbol.trim()) ||
            (greekControllerParams === null || greekControllerParams === void 0 ? void 0 : greekControllerParams.Exch) === exchangeToCheck)) {
            if (sessionStorage.getItem("PriceGreek") == null) {
                span_tag.innerHTML = "Price";
                sessionStorage.setItem("PriceGreek", "Price");
            }
            else {
                sessionStorage.getItem("PriceGreek") == "Price"
                    ? (span_tag.innerHTML = "Price")
                    : (span_tag.innerHTML = "Greeks");
            }
        }
        else {
            span_tag.innerHTML = "Price";
            sessionStorage.setItem("PriceGreek", "Price");
        }
        //close option chain button
        buttonContainer.style.border = "none";
        buttonContainer.style.display = "flex";
        buttonContainer.style.padding = "0px";
        buttonContainer.style.justifyContent = "center";
        buttonContainer.style.alignItems = "center";
        buttonContainer.style.position = "absolute";
        buttonContainer.style.top = "18px";
        buttonContainer.style.right = "10px";
        buttonContainer.style.width = "24px";
        buttonContainer.style.height = "24px";
        buttonContainer.style.zIndex = "999";
        buttonContainer.addEventListener("mousemove", function (event) {
            event.stopPropagation(); // Stop event propagation to parent elements
        });
        var newBtn = document.createElement("button");
        newBtn.style.backgroundColor = "transparent";
        newBtn.style.border = "none";
        newBtn.style.alignItems = "center";
        newBtn.style.justifyContent = "center";
        newBtn.style.padding = "10px 20px";
        newBtn.style.display = "flex";
        newBtn.style.cursor = "pointer";
        newBtn.appendChild(icon);
        buttonContainer.appendChild(newBtn);
        newBtn.addEventListener("mouseenter", function () {
            var closeText = document.createElement("span");
            closeText.textContent = "Close";
            closeText.style.color = "#475467";
            closeText.style.fontSize = "12px";
            closeText.style.position = "absolute";
            closeText.style.top = "140%";
            closeText.style.border = "1px solid #6C94B836";
            closeText.style.borderRadius = "2px";
            closeText.style.backgroundColor = "#dee2e6";
            closeText.style.padding = "2px";
            closeText.style.left = "50%";
            closeText.style.transform = "translate(-50%, -50%)";
            closeText.style.opacity = "0";
            closeText.style.transition = "opacity 0.3s ease";
            // Append the text element to the button
            newBtn.appendChild(closeText);
            // Set opacity to 1 to show the text
            setTimeout(function () {
                closeText.style.opacity = "1";
            }, 10); // Delay to ensure transition effect is applied
        });
        newBtn.addEventListener("mouseleave", function () {
            var closeText = newBtn.querySelector("span");
            if (closeText) {
                closeText.style.opacity = "0";
                setTimeout(function () {
                    newBtn.removeChild(closeText);
                }, 300); // Delay to match the transition duration
            }
        });
        newBtn.addEventListener("click", function () {
            newDiv.remove();
            myDiv.style.display = "none";
        });
        newDiv.addEventListener("click", (event) => {
            if (dropDownOptionsContainer.style.display == "block") {
                dropDownOptionsContainer.style.display = "none";
            }
        });
        let myFrames = document.getElementsByTagName("iframe");
        let myFramesContent = myFrames[1].contentDocument.body;
        let aa = myFramesContent.getElementsByClassName("js-rootresizer__contents");
        newDiv.addEventListener("dragstart", drag_start);
        newDiv.addEventListener("dragover", drag_over);
        newDiv.addEventListener("drop", drop);
        myDiv.addEventListener("dragstart", drag_start);
        myDiv.addEventListener("dragover", drag_over);
        myDiv.addEventListener("drop", drop);
        iframe2.addEventListener("dragstart", drag_start);
        iframe2.addEventListener("dragover", drag_over);
        iframe2.addEventListener("drop", drop);
        aa[0].addEventListener("dragstart", drag_start);
        aa[0].addEventListener("dragover", drag_over);
        aa[0].addEventListener("drop", drop);
        window.is_DragOver = false;
        window.is_Drop = false;
        let myTimeout;
        function drag_start(event) {
            myDiv.style.display = "block";
            iframe2.style.display = "none";
            if (myTimeout)
                clearTimeout(myTimeout);
            myTimeout = setTimeout(function () {
                if (window.is_DragOver == false) {
                    iframe2.style.display = "block";
                    myDiv.style.display = "none";
                }
            }, 1000);
            var style = window.getComputedStyle(event.target, null);
            var str = parseInt(style.getPropertyValue("left")) -
                event.clientX +
                "," +
                (parseInt(style.getPropertyValue("top")) - event.clientY) +
                "," +
                event.target.id;
            event.dataTransfer.setData("Text", str);
        }
        function drop(event) {
            window.is_Drop = true;
            iframe2.style.display = "block";
            myDiv.style.display = "none";
            window.is_DragOver = false;
            var offset = event.dataTransfer.getData("Text").split(",");
            var dm = document.getElementById(offset[2]);
            dm.style.left = event.clientX + parseInt(offset[0], 10) + "px";
            dm.style.top = event.clientY + parseInt(offset[1], 10) + "px";
            event.preventDefault();
            return false;
        }
        function drag_over(event) {
            window.is_DragOver = true;
            window.is_Drop = false;
            event.preventDefault();
            return false;
        }
    }
    bringToFront(newDiv);
}
//Helper to adapt CWA2Sigma to TradingView v28+ custom indicator API
function makeCWA2SigmaIndicator(PineJS) {
    return CWA2SigmaIndicator(PineJS);
}
function makeAllCandlestickPatterns(PineJS) {
    return AllCandlestickPatterns(PineJS);
}
// for accessing JWTToken for android/iOS/flutter
var osParam = reqUrl.searchParams.get("osName");
var paramJwt = "";
if (osParam === "Android") {
    paramJwt = AndroidNativeInterface.getCookie();
}
else if (osParam === "iOS") {
    callMyFunction(paramJwt);
}
if (paramJwt) {
    localStorage.setItem("paramJwt", paramJwt);
}
const override = {
    "mainSeriesProperties.showCountdown": !1,
    "mainSeriesProperties.style": 1,
    "paneProperties.horzGridProperties.style": 5,
    "paneProperties.vertGridProperties.style": 5,
    "paneProperties.bottomMargin": 10,
    "mainSeriesProperties.showPrevClosePriceLine": true,
    "paneProperties.background": "#020024",
};
const overridesForApp = {
    "paneProperties.legendProperties.showSeriesTitle": false,
    "paneProperties.legendProperties.showSeriesOHLC": true,
    "paneProperties.legendProperties.showStudyTitles": true,
    "paneProperties.legendProperties.showStudyValues": true,
    "paneProperties.legendProperties.showBarChange": false,
    "mainSeriesProperties.showCountdown": !1,
    "mainSeriesProperties.style": 1,
    "paneProperties.horzGridProperties.style": 5,
    "paneProperties.vertGridProperties.style": 5,
    "paneProperties.bottomMargin": 10,
    "mainSeriesProperties.showPrevClosePriceLine": true,
    "paneProperties.background": "#020024",
};
// Start tracking chart loading time
const chartLoadStartTime = performance.now();
window.tvWidget = new widget({
    symbol: reqExch +
        ":" +
        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName.trim()) +
        "/" +
        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode) +
        "-" +
        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ExchType),
    interval: interval,
    fullscreen: true,
    container: "tv_chart_container",
    datafeed: Datafeed,
    timezone: "Asia/Kolkata",
    custom_font_family: "supreme",
    library_path: "charting_library_clonned_data/charting_library/",
    disabled_features: disabledfeatures,
    enabled_features: enabled_features,
    allow_symbol_change: false,
    custom_css_url: "custom_style.css",
    auto_save_delay: 5,
    charts_storage_url: !!userId ? `${APP_BASE_CHARTSLAYOUT_API_URL}api` : null,
    charts_storage_api_version: !!userId ? "v1.0" : null,
    client_id: !!userId ? "5p-tv" : null,
    user_id: !!userId ? localStorage.getItem("ClientCode") : null,
    overrides: isNewApp === "true" ? overridesForApp : override,
    studies_overrides: {
        "volume.volume.transparency": 75,
    },
    save_load_adapter: {
        charts: [],
        studyTemplates: [],
        drawingTemplates: [],
        getAllCharts: function () {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                sessionStorage.setItem("chartContentFlag_Tradechart", chartContentFlag_Tradechart);
            }
            else {
                sessionStorage.setItem("chartContentFlag_noTradechart", chartContentFlag_noTradechart);
            }
            let fetchData = (url, headers) => {
                return new Promise((resolve, reject) => {
                    fetch(url, { method: "GET", headers: headers })
                        .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not OK");
                        }
                        resolve(response.json().then((res) => res));
                    })
                        .catch((error) => reject(error));
                });
            };
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            };
            return Promise.resolve(fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/charts?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, headers));
        },
        removeChart: function (id) {
            function fetchData(url, requestOptions) {
                return new Promise((resolve, reject) => {
                    fetch(url, requestOptions)
                        .then((response) => {
                        if (!response.ok) {
                            // const error = new Error("Network response was not OK");
                            loggly_util.logAdvancedMessage(response, {
                                error: response.statusText,
                                APIURL: url,
                                Windowurl: window.location.href,
                                Token: JSON.parse(localStorage.TokenResponseTv).access_token,
                                JWTTOKEN: localStorage
                                    .getItem("JWTToken")
                                    .replaceAll("JwtToken=", ""),
                            });
                            throw new Error("Network response was not OK");
                        }
                        return response.json(); // Ensure to return the JSON response here
                    })
                        .then((data) => resolve(data)) // Resolve the promise with the parsed data
                        .catch((error) => reject(error));
                });
            }
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            };
            const raw = JSON.stringify({
                layout: id.trim(),
            });
            const requestOptions = {
                method: "POST",
                headers: headers,
                body: raw,
                redirect: "follow",
            };
            return fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/charts/DeleteLayout/?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, requestOptions)
                .then((response) => {
                // Handle the response data here if needed
            })
                .catch((error) => {
                console.error("Error:", error);
            });
            return Promise.reject();
        },
        saveChart: function (chartData) {
            var _a;
            const layoutUrl = `${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/charts?client=5p-tv&user=${localStorage.getItem("ClientCode")}`;
            let saveOrUpdateLayout = (isUpdate, chartId = null) => {
                var _a;
                let saveMethod = isUpdate ? "POST" : "POST";
                let saveUrl = layoutUrl;
                if (isUpdate && chartId) {
                    saveUrl += `&chart=${chartId}`;
                }
                fetch(saveUrl, {
                    method: saveMethod,
                    body: JSON.stringify({
                        name: chartData.name.trim(),
                        content: chartData.content,
                        completed: false,
                        symbol: chartData.symbol,
                        resolution: chartData.resolution,
                        theme: themeVal,
                    }),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                            ? "Bearer " +
                                ((_a = localStorage.getItem("paramJwt")) === null || _a === void 0 ? void 0 : _a.replaceAll("JwtToken=", ""))
                            : "Bearer " + localStorage.getItem("JWTToken"),
                        "Cache-Control": "no-cache,no-store",
                    },
                })
                    .then((response) => response.json())
                    .then((json) => {
                    console.log("Save/Update response:", json);
                });
            };
            fetch(layoutUrl, {
                method: "GET",
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                        ? "Bearer " +
                            ((_a = localStorage.getItem("paramJwt")) === null || _a === void 0 ? void 0 : _a.replaceAll("JwtToken=", ""))
                        : "Bearer " + localStorage.getItem("JWTToken"),
                    "Cache-Control": "no-cache,no-store",
                },
            })
                .then((response) => response.json())
                .then((layouts) => {
                console.log("Fetched layouts:", layouts);
                if (Array.isArray(layouts)) {
                    const chartId = chartData.id || null;
                    let isUpdate = false;
                    if (chartId) {
                        const existingLayout = layouts.find((layout) => layout.id === chartId);
                        if (existingLayout) {
                            console.log("Renaming existing layout with ID:", chartId);
                            isUpdate = true;
                        }
                    }
                    else {
                        const existingLayout = layouts.find((layout) => layout.name === chartData.name.trim());
                        if (existingLayout) {
                            isUpdate = true;
                        }
                    }
                    if (!isUpdate) {
                    }
                    saveOrUpdateLayout(isUpdate, chartId);
                }
                else {
                    console.error("Unexpected response structure for layouts:", layouts);
                }
            })
                .catch((error) => console.error("Error fetching layouts:", error));
            // Capture event for saving layout
            captureEvent("Top_Menu_Click", {
                ClientCode: localStorage.getItem("ClientCode"),
                Action: "Save_Layout",
                Script_Name: tvWidget.activeChart().symbol(),
                Chart_Type_Selected: "Trading View"
            });
        },
        getChartContent: function (id) {
            let fetchData = (url, headers) => {
                return new Promise((resolve, reject) => {
                    fetch(url, { method: "GET", headers: headers })
                        .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not OK");
                        }
                        resolve(response.json());
                    })
                        .catch((error) => reject(error));
                });
            };
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
                // "Bearer " + localStorage.getItem("JWTToken").replaceAll("JwtToken=", ""),
            };
            return Promise.resolve(fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/charts/${id}?client=5p-tv&user=${localStorage.getItem("ClientCode")}&chart=${id.trim()}`, headers).then((responseData) => {
                if (reqUrl.searchParams.get("isTradeChart") === "true") {
                    chartContentFlag_Tradechart = true;
                    sessionStorage.setItem("chartContentFlag_Tradechart", chartContentFlag_Tradechart);
                    sessionStorage.setItem("load_symbols_Tradechart", JSON.parse(responseData.data.content).charts_symbols);
                    let newLoadObj = JSON.parse(JSON.parse(responseData.data.content).charts_symbols);
                    let ChartsContent = JSON.parse(JSON.parse(responseData.data.content).content);
                    sessionStorage.setItem("chartContent_loadLayout", JSON.stringify(ChartsContent));
                    if (ChartsContent.charts.length > 1) {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_Tradechart", JSON.stringify(ChartsContent));
                    }
                    else {
                        //let syms = newLoadObj[1].symbol;
                        let sym_a = newLoadObj[1].symbol.split("/")[1].split("-")[0];
                        sessionStorage.setItem("autoSaveStorage_Tradechart" + sym_a, JSON.stringify(ChartsContent));
                    }
                    let arrObj = [];
                    for (let key in newLoadObj) {
                        arrObj.push(newLoadObj[key].symbol);
                        try {
                            let mapKey = getExch_Exchtype_Scripcode(newLoadObj[key].symbol);
                            if (window.layoutMap != null && window.layoutMap != undefined && window.layoutMap.has(mapKey.symbol)) {
                                window.layoutMap.delete(mapKey.symbol);
                            }
                        }
                        catch (e) {
                            console.error(e);
                        }
                    }
                    sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(arrObj));
                    let layout = JSON.parse(responseData.data.content);
                    captureEvent("Top_Menu_Click", {
                        ClientCode: localStorage.getItem("ClientCode"),
                        Action: "Load_Layout",
                        Layout_loaded: layout.name,
                        Chart_Type_Selected: "Trading View"
                    });
                }
                return (responseData = responseData.data.content);
            }));
            return Promise.reject();
        },
        removeStudyTemplate: function (studyTemplateData) {
            // getAuthToken()
            function fetchData(url, requestOptions) {
                return new Promise((resolve, reject) => {
                    fetch(url, requestOptions)
                        .then((response) => {
                        if (!response.ok) {
                            const error = new Error("Network response was not OK");
                            loggly_util.logAdvancedMessage(error, {
                                error: error.message,
                                APIURL: url,
                                Windowurl: window.location.href,
                                Token: JSON.parse(localStorage.TokenResponseTv).access_token,
                                JWTTOKEN: localStorage
                                    .getItem("JWTToken")
                                    .replaceAll("JwtToken=", ""),
                            });
                            throw new Error("Network response was not OK");
                        }
                        resolve(); // Resolve with empty response
                    })
                        .catch((error) => {
                        reject(error);
                    });
                });
            }
            const osParam = reqUrl.searchParams.get("osName");
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            };
            const raw = JSON.stringify({
                template: studyTemplateData.name.trim(),
            });
            const requestOptions = {
                method: "POST",
                headers: headers,
                body: raw,
                redirect: "follow",
            };
            return fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/study_templates/DeleteTemplate/?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, requestOptions);
        },
        getStudyTemplateContent: function (studyTemplateData) {
            let fetchData = (url, headers) => {
                return new Promise((resolve, reject) => {
                    fetch(url, { method: "GET", headers: headers })
                        .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not OK");
                        }
                        resolve(response.json());
                        // or response.text() for plain text
                    })
                        .catch((error) => reject(error));
                });
            };
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            };
            return Promise.resolve(fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}/api/v1.0/study_templates/${studyTemplateData.name}?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, headers).then((responseData) => {
                // Handle the response data here
                localStorage.setItem("studyCode", responseData.data.scripcode);
                localStorage.setItem("studyexchangeType", responseData.data.exchType);
                localStorage.setItem("studyexchange", responseData.data.exchange);
                if (typeof responseData.data.content == "string") {
                    return (responseData = JSON.stringify(JSON.parse(responseData.data.content)));
                }
                else {
                    return (responseData = JSON.parse(responseData.data.content));
                }
            }));
            return Promise.reject();
        },
        saveStudyTemplate: function (studyTemplateData) {
            var res;
            fetch(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/study_templates?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, {
                method: "POST",
                body: JSON.stringify({
                    name: studyTemplateData.name.trim(),
                    content: studyTemplateData.content,
                    scripcode: Datafeed.urlParameter.scripCode,
                    exchType: Datafeed.urlParameter.exchType,
                    exchange: Datafeed.urlParameter.exchange,
                    completed: false,
                }),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    Authorization: osParam === "Android" ||
                        osParam === "iOS" ||
                        osParam === "flutter"
                        ? "Bearer " +
                            localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                        : "Bearer " + localStorage.getItem("JWTToken"),
                    "Cache-Control": "no-cache,no-store",
                },
            })
                .then((response) => response.json())
                .then((json) => {
                res = json;
            });
            captureEvent("Top_Menu_Click", {
                ClientCode: localStorage.getItem("ClientCode"),
                Action: "Save_Indicator_Template",
                Template_Name: studyTemplateData.name.trim(),
                Script_Name: tvWidget.activeChart().symbol(),
                Chart_Type_Selected: "Trading View"
            });
            return Promise.resolve();
        },
        getAllStudyTemplates: function (studyTemplateData) {
            var res;
            let fetchData = (url, headers) => {
                return new Promise((resolve, reject) => {
                    fetch(url, { method: "GET", headers: headers })
                        .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not OK");
                        }
                        resolve(response.json().then((res) => res.data)); // or response.text() for plain text
                    })
                        .catch((error) => reject(error));
                });
            };
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        localStorage.getItem("paramJwt").replaceAll("JwtToken=", "")
                    : "Bearer " + localStorage.getItem("JWTToken"),
            };
            return Promise.resolve(fetchData(`${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/study_templates/${studyTemplateData.name}?client=5p-tv&user=${localStorage.getItem("ClientCode")}`, headers).then((responseData) => {
                // Handle the response data here
                localStorage.setItem("studyCode", responseData.data.scripcode);
                localStorage.setItem("studyexchangeType", responseData.data.exchType);
                localStorage.setItem("studyexchange", responseData.data.exchange);
                if (typeof responseData.data.content == "string") {
                    return (responseData = JSON.stringify(JSON.parse(responseData.data.content)));
                }
                else {
                    return (responseData = JSON.parse(responseData.data.content));
                }
            }));
            return Promise.reject();
        },
        getAllStudyTemplates: function () {
            var _a;
            function fetchWithTimeout(url, headers, timeout = 10000) {
                return Promise.race([
                    fetch(url, {
                        method: "GET",
                        headers: headers
                    }),
                    new Promise((_, reject) => setTimeout(() => reject(new Error("Request timed out")), timeout)),
                ]);
            }
            const headers = {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: osParam === "Android" || osParam === "iOS" || osParam === "flutter"
                    ? "Bearer " +
                        ((_a = localStorage.getItem("paramJwt")) === null || _a === void 0 ? void 0 : _a.replaceAll("JwtToken=", ""))
                    : "Bearer " + localStorage.getItem("JWTToken"),
                "Cache-Control": "no-cache,no-store",
            };
            const url = `${APP_BASE_CHARTSLAYOUT_API_URL}api/v1.0/study_templates?client=5p-tv&user=${localStorage.getItem("ClientCode")}`;
            return fetchWithTimeout(url, headers)
                .then((response) => {
                if (!response.ok) {
                    return response.text().then((text) => {
                        throw new Error(`Error: ${response.status} - ${text}`);
                    });
                }
                return response.json().then((res) => res.data);
            })
                .catch((error) => {
                console.error("Failed to fetch study templates:", error);
                throw error;
            });
        },
    },
    widgetbar: {
        details: data_window,
        news: false,
        watchlist: data_window,
        datawindow: data_window,
        watchlist_settings: {
            default_symbols: [],
        },
    },
    broker_factory: function (host) {
        const reqUrl = new URL(window.location);
        try {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                if (!brokerFac) {
                    brokerFac = new BrokerSample(host, Datafeed);
                }
            }
            return brokerFac;
        }
        catch (error) {
            console.log("error", error);
        }
    },
    broker_config: {
        configFlags: {
            supportPlaceOrderPreview: true,
            supportBottomWidget: true,
            supportNativeReversePosition: true,
            supportClosePosition: true,
            supportPLUpdate: true,
            supportLevel2Data: true,
            showQuantityInsteadOfAmount: true,
            supportEditAmount: true,
            supportOrderBrackets: false,
            supportMarketBrackets: true,
            supportPositionBrackets: false,
            supportModifyOrderType: true,
            supportModifyOrderPrice: true,
            supportModifyDuration: true,
            supportModifyBrackets: true,
            supportStopLimitOrders: true,
            supportModifyOrderPreview: true,
            showNotificationsLog: false,
        },
        durations: [
            {
                name: "DAY",
                value: "DAY",
                supportedOrderTypes: [1, 3, 4],
                default: true
            },
            {
                name: "IOC",
                value: "IOC",
                supportedOrderTypes: [1],
                default: true
            },
        ],
        orderDialogOptions: {
            customFields: [
                {
                    id: "2410",
                    inputType: "ComboBox",
                    title: "Product",
                    items: [
                        {
                            text: `${localStorage.getItem("productVal")}`,
                            value: "Intraday",
                        },
                        {
                            text: `${localStorage.getItem("productVal")}`,
                            value: "Delivery",
                        },
                    ],
                },
            ],
        },
    },
    context_menu: {
        items_processor: function (items, actionsFactory, params) {
            const reqUrll = new URL(window.location);
            if (reqUrll.searchParams.get("isTradeChart") === "false") {
                let new_arr = [];
                for (let i = 0; i < items.length; i++) {
                    if (!(items[i].type == "action" &&
                        items[i]._options.actionId == "Trading.TradeFromChart")) {
                        new_arr.push(items[i]);
                    }
                    else {
                        if (i != 0 && items[i - 1].type == "separator") {
                            new_arr.pop(items[i - 1]);
                        }
                    }
                }
                if (params.menuName === "CrosshairMenuView") {
                    let arr_new = [];
                    arr_new = items.slice(4);
                    return Promise.resolve(arr_new);
                }
                return Promise.resolve(new_arr);
            }
            else {
                return Promise.resolve(items);
            }
        },
    },
    custom_translate_function: (key, options) => {
        if (key === "Units") {
            return "Quantity";
        }
        if (key === "Stop price") {
            return "Trigger Price";
        }
        if (key === "Time in force") {
            return "Validity";
        }
        if (key === "Add custom interval") {
            return "Add Custom Interval";
        }
        return key;
    },
    time_frames: timeFrameArr,
    debug: false,
    theme: themeVal,
    custom_indicators_getter: function (PineJS) {
        return Promise.resolve([
            makeCWA2SigmaIndicator(PineJS),
            makeAllCandlestickPatterns(PineJS)
        ]);
    },
});
function changeThemeFun(themeVal, tvWidget) {
    if (themeVal === "dark" || themeVal === "Dark") {
        setTimeout(() => {
            tvWidget.changeTheme("Dark");
        }, 500);
    }
    else {
        setTimeout(() => {
            tvWidget.changeTheme("Light");
        }, 500);
    }
}
const isTradeChartMode = reqUrl.searchParams.get("isTradeChart") === "true";
// Default to false when key is absent — only enable if explicitly saved as "true"
let oiProfileEnabled = isTradeChartMode && localStorage.getItem(OI_PROFILE_STORAGE_KEY) === "true";
// Track all OI canvases for show/hide
const oiCanvasList = [];
const oiDataMap = new Map();
const handleOiWebsocketUpdate = createOiWebsocketUpdateHandler(oiDataMap);
const fetchOiDataForPane = createFetchOiDataForPane({
    oiDataMap,
    get ScripInfoDetails() { return ScripInfoDetails; },
    getOiProfileData,
    subscribeToData,
    SOCKET_SUBSCRIPTION_METHODS,
    METHOD_FOR_CHART_SOCKET,
    handleOiWebsocketUpdate,
});
if (sessionStorage.getItem("__cInternal") === "true") {
    window.tvWidget.onChartReady(async () => {
        const chart = tvWidget.activeChart();
        // OI PROFILE — only initialise when isTradeChart=true
        const priceRangeMap = new Map();
        let statusDiv;
        // Calculate chart loading time
        const chartLoadEndTime = performance.now();
        const chartLoadingTime = Math.round(chartLoadEndTime - chartLoadStartTime);
        const chartLoadingTimeSeconds = (chartLoadingTime / 1000).toFixed(2);
        // Send chart loading time to CleverTap
        captureEvent("Chart_Load", {
            ClientCode: localStorage.getItem("ClientCode"),
            Script_Name: sessionStorage.getItem("load_symbols_Tradechart") || sessionStorage.getItem("load_symbols_noTradechart"),
            Chart_Loading_Time_MS: chartLoadingTime,
            Chart_Loading_Time_Seconds: chartLoadingTimeSeconds,
            Action: "Chart_Loaded_Successfully"
        });
        try {
            const isTradeChartFalse = reqUrl.searchParams.get("isTradeChart") === "false";
            const finalPaneIndex = isTradeChartFalse ? 0 : Number(paneIndex);
            let objectData = JSON.parse(AutoSaveApiData.data.content);
            let updatedData = updateMainSeries(objectData, reqSymbol, ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName, finalPaneIndex);
            tvWidget.load(updatedData);
            localStorage.setItem("onAutoSaveNeededData", JSON.stringify(updatedData));
        }
        catch (error) {
            console.error("Error parsing JSON:", error);
        }
        if (isNewApp === "true") {
            const iframe = document.getElementById("tv_chart_container").getElementsByTagName("iframe")[0];
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            statusDiv = iframeDoc.querySelector(".statusesWrapper-l31H9iuA");
            if (statusDiv)
                statusDiv.style.display = "none";
            tvWidget.applyOverrides({
                "paneProperties.legendProperties.showSeriesTitle": false,
                "paneProperties.legendProperties.showSeriesOHLC": true,
                "paneProperties.legendProperties.showStudyTitles": true,
                "paneProperties.legendProperties.showStudyValues": true,
                "paneProperties.legendProperties.showBarChange": false,
            });
        }
        else {
            if (statusDiv)
                statusDiv.style.display = "block";
            tvWidget.applyOverrides({
                "paneProperties.legendProperties.showSeriesTitle": true,
                "paneProperties.legendProperties.showSeriesOHLC": true,
                "paneProperties.legendProperties.showStudyTitles": true,
                "paneProperties.legendProperties.showStudyValues": true,
                "paneProperties.legendProperties.showBarChange": true,
            });
        }
        let checkUnsubscribeSocket;
        document.addEventListener("visibilitychange", function (event) {
            if (document.hidden) {
                checkUnsubscribeSocket = setTimeout(() => {
                    const allLayoutSymbols = new Set();
                    for (let i = 0; i < window.tvWidget.chartsCount(); i++) {
                        const { ScripCode } = getExch_Exchtype_Scripcode(tvWidget.chart(i).symbolExt().ticker);
                        if (ScripCode) {
                            allLayoutSymbols.add(ScripCode);
                        }
                    }
                    onFocusChange(false, [...allLayoutSymbols]);
                }, 25000);
            }
            else {
                if (checkUnsubscribeSocket) {
                    clearTimeout(checkUnsubscribeSocket);
                    checkUnsubscribeSocket = null;
                }
                onFocusChange(true);
            }
        });
        if (reqUrl.searchParams.get("searchFlag") === "true") {
            let params = new URLSearchParams(reqUrl.search);
            params.delete("searchFlag");
            const updatedUrl = `${reqUrl.origin}${reqUrl.pathname}?${params.toString()}`;
            window.history.pushState({}, "", updatedUrl);
        }
        // To track the last known state of the tab
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                observeTabChanges(brokerFac);
            }
        }
        async function changeURLByAutoSave(name) {
            let reqD = await AlterUrlParam(name);
            await changeURLparam(reqD);
        }
        tvWidget.subscribe("onAutoSaveNeeded", function (res) {
            sessionStorage.setItem("indicatorFlag", true);
            setTimeout(() => {
                tvWidget.save(async function (res) {
                    let resInString = JSON.stringify(res);
                    let resInterval = tvWidget.chart().resolution();
                    let activeSymbol = tvWidget.activeChart().symbol();
                    let activeLayoutName = "5Paisa";
                    let appType = "tv";
                    if (osName === "flutter") {
                        appType = isNewApp === "true" ? "newApp" : "oldApp";
                    }
                    try {
                        await postAutoSavePrefData(resInterval, activeLayoutName, activeSymbol, resInString, appType);
                    }
                    catch (error) {
                        console.error("Error saving auto-save data in api:", error);
                    }
                    localStorage.setItem("onAutoSaveNeededData", resInString);
                });
            }, 120);
        });
        window.tvWidget.subscribe("layout_about_to_be_changed", async function (LayoutType) {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                if (LayoutType != "s") {
                    sessionStorage.setItem("isMultiLayOut_Tradechart", "true");
                }
                else {
                    sessionStorage.setItem("isMultiLayOut_Tradechart", "false");
                }
                try {
                    let dd = document
                        .getElementById("tv_chart_container")
                        .getElementsByTagName("iframe")[0]
                        .contentDocument.getElementsByTagName("body")[0]
                        .querySelector(".chart-gui-wrapper")
                        .querySelector("#parentBuySell");
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") == "true") {
                        dd.style.display = "none";
                    }
                    else {
                        dd.style.display = "block";
                    }
                }
                catch (error) {
                    // console.log(error);
                }
                window.tvWidget.save(async function (res) {
                    sessionStorage.setItem("LayoutType_Tradechart", LayoutType);
                    let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"))[sessionStorage.getItem("activeChartChanged_Tradechart")]);
                    await changeURLparam(reqD);
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") == "true" &&
                        sessionStorage.getItem("chartContentFlag_Tradechart") != "true") {
                        var symbolInfoDataa = JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"));
                        if (checkingLayoutType(LayoutType) > symbolInfoDataa.length) {
                            var lenn = checkingLayoutType(LayoutType) - symbolInfoDataa.length;
                            for (let i = 0; i < lenn; i++) {
                                symbolInfoDataa.push(symbolInfoDataa[symbolInfoDataa.length - 1]);
                            }
                            sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(symbolInfoDataa));
                        }
                        else {
                            var newarrr = [];
                            for (let i = 0; i < checkingLayoutType(LayoutType); i++) {
                                newarrr.push(symbolInfoDataa[i]);
                            }
                            sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(newarrr));
                        }
                    }
                });
            }
            else {
                if (LayoutType != "s") {
                    sessionStorage.setItem("isMultiLayOut_noTradechart", "true");
                    tvWidget.save(function (res) {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_noTradechart", JSON.stringify(res));
                    });
                }
                else {
                    if (reqUrl.searchParams.get("searchFlag") === "true")
                        sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(res));
                }
                try {
                    let dd = document
                        .getElementById("tv_chart_container")
                        .getElementsByTagName("iframe")[0]
                        .contentDocument.getElementsByTagName("body")[0]
                        .querySelector(".chart-gui-wrapper")
                        .querySelector("#parentBuySell");
                    if (sessionStorage.getItem("isMultiLayOut_noTradechart") == "true") {
                        dd.style.display = "none";
                    }
                    else {
                        dd.style.display = "block";
                    }
                }
                catch (error) {
                    // console.log(error);
                }
                tvWidget.save(async function (res) {
                    sessionStorage.setItem("LayoutType_noTradechart", LayoutType);
                    sessionStorage.setItem("isMultiLayOut_noTradechart", "true");
                    let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"))[sessionStorage.getItem("activeChartChanged_noTradechart")]);
                    await changeURLparam(reqD);
                    if (sessionStorage.getItem("isMultiLayOut_noTradechart") == "true" &&
                        sessionStorage.getItem("chartContentFlag_noTradechart") != "true") {
                        var symbolInfoDataa = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                        if (checkingLayoutType(LayoutType) > symbolInfoDataa.length) {
                            var lenn = checkingLayoutType(LayoutType) - symbolInfoDataa.length;
                            for (let i = 0; i < lenn; i++) {
                                symbolInfoDataa.push(symbolInfoDataa[symbolInfoDataa.length - 1]);
                            }
                            sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(symbolInfoDataa));
                        }
                        else {
                            var newarrr = [];
                            for (let i = 0; i < checkingLayoutType(LayoutType); i++) {
                                newarrr.push(symbolInfoDataa[i]);
                            }
                            sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(newarrr));
                        }
                    }
                });
            }
        });
        let symbolSubscription = null;
        function subscribeToActiveChart() {
            if (symbolSubscription) {
                symbolSubscription.unsubscribe();
                symbolSubscription = null;
            }
            const activeChart = window.tvWidget.activeChart();
            symbolSubscription = activeChart.onSymbolChanged().subscribe(null, async (symbol) => {
                if (reqUrl.searchParams.get("isTradeChart") === "true") {
                    let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"));
                    if (getLoadSymbl) {
                        getLoadSymbl[sessionStorage.getItem("activeChartChanged_Tradechart")] =
                            !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                                ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                                : symbol.ticker;
                        sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(getLoadSymbl));
                    }
                    if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                        let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                        await changeURLparam(reqD);
                    }
                    else {
                        let reqD = await AlterUrlParam(symbol.ticker);
                        await changeURLparam(reqD);
                    }
                }
                else {
                    let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                    if (getLoadSymbl) {
                        getLoadSymbl[sessionStorage.getItem("activeChartChanged_noTradechart")] =
                            !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                                ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                                : symbol.ticker;
                        sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(getLoadSymbl));
                    }
                    if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                        let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                        await changeURLparam(reqD);
                    }
                    else {
                        let reqD = await AlterUrlParam(symbol.ticker);
                        await changeURLparam(reqD);
                    }
                }
            });
        }
        window.tvWidget.subscribe("activeChartChanged", async function (index) {
            subscribeToActiveChart();
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                for (let i = 0; i < window.tvWidget.chartsCount(); i++) {
                    if (i == index) {
                        window.tvWidget.activeChart();
                    }
                }
                window.tvWidget.save(function (res) {
                    sessionStorage.setItem("activeChartChanged_Tradechart", index);
                    let chartChangeArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        if (i == index) {
                            let getLocalAutoSaveData = chartSetting_Tradechart;
                            if (getLocalAutoSaveData) {
                                getLocalAutoSaveData.charts[0] = res.charts[i];
                                sessionStorage.setItem("autoSaveStorage_Tradechart" + sessionScripCode, JSON.stringify(getLocalAutoSaveData));
                            }
                        }
                        res.charts[i].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                chartChangeArr.push(pane.sources[0].state.symbol);
                            }
                        });
                    }
                    sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(chartChangeArr));
                });
                let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"))[index]);
                await changeURLparam(reqD);
                //hiding the timeframe according to the condition
                function postMessageURLparams() {
                    var _a, _b;
                    let url = new URL(window.location);
                    let newUrlParam = url.searchParams;
                    let name = `${reqD === null || reqD === void 0 ? void 0 : reqD.ShortName}`;
                    let symbolName = `${reqD === null || reqD === void 0 ? void 0 : reqD.ShortName}`;
                    if ((reqD === null || reqD === void 0 ? void 0 : reqD.ExchType) !== "C") {
                        name += `${reqD === null || reqD === void 0 ? void 0 : reqD.Expiry}`;
                        if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) === "OPTIONS") {
                            name += ` ${reqD === null || reqD === void 0 ? void 0 : reqD.CPType}`;
                        }
                        if (reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) {
                            name += ` ${reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate.replaceAll(".00", "")}`;
                        }
                    }
                    var myObj = {
                        fullName: name,
                        exchange: getExchangeName(reqD === null || reqD === void 0 ? void 0 : reqD.Exch),
                        exchangeType: reqD === null || reqD === void 0 ? void 0 : reqD.ExchType,
                        symbol: reqD === null || reqD === void 0 ? void 0 : reqD.ShortName,
                        scripCode: reqD === null || reqD === void 0 ? void 0 : reqD.ScripCode,
                        optionType: (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "CE" || (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "PE" ? reqD === null || reqD === void 0 ? void 0 : reqD.CPType : "",
                        strikePrice: (_a = reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) !== null && _a !== void 0 ? _a : "",
                        expiry: (_b = reqD === null || reqD === void 0 ? void 0 : reqD.Expiry) !== null && _b !== void 0 ? _b : "",
                        isSearch: true,
                    };
                    return myObj;
                }
                window.parent.postMessage(postMessageURLparams(), window.location.ancestorOrigins[0]);
                if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "EQUITY" &&
                    (reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "INDICE") {
                    try {
                        setTimeout(function () {
                            const btnArray = ["1Y", "5Y", "Max"];
                            let ddd = document
                                .getElementById("tv_chart_container")
                                .getElementsByTagName("iframe")[0]
                                .contentDocument.getElementsByTagName("body")[0]
                                .querySelector(".dateRangeExpanded-BXXUwft2");
                            let reqDivs = ddd
                                .querySelectorAll("div")[0]
                                .querySelectorAll("button");
                            reqDivs.forEach((div) => {
                                if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                    div.style.display = "none";
                                }
                            });
                        }, 1000);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
            }
            else {
                for (let i = 0; i < tvWidget.chartsCount(); i++) {
                    if (i == index) {
                        tvWidget
                            .activeChart()
                            .onIntervalChanged()
                            .subscribe(null, (interval, timeframeObj) => {
                            if (interval == "1D") {
                                var allSym = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                                let newA = [];
                                for (let i = 0; i < allSym.length; i++) {
                                    let matches = allSym[i].split("/")[1];
                                    newA.push(matches);
                                }
                                sessionStorage.setItem("layoutScArr_noTradechart", JSON.stringify(newA));
                            }
                            Datafeed.urlParameter.searchFlag === "true"
                                ? sessionStorage.setItem("reso" + sessionScripCode, interval)
                                : localStorage.setItem("reso", interval);
                            var feedLength = localStorage.getItem("length");
                            if (Datafeed.urlParameter.type == "futures" ||
                                Datafeed.urlParameter.type == "options" ||
                                Datafeed.urlParameter.type == "options-curcom" ||
                                Datafeed.urlParameter.type == "future-curcom" ||
                                Datafeed.urlParameter.type == "Future-curcom") {
                                if ([
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "10",
                                    "15",
                                    "30",
                                    "60",
                                    "240",
                                ].includes(interval)) {
                                    if (localStorage.getItem("intraDaydata_noTradechart") > 0 &&
                                        localStorage.getItem("socket_noTradechart") == "false") {
                                        //document.getElementById("error_msg").style.display = "none";
                                    }
                                }
                                else if (feedLength == 0 &&
                                    localStorage.getItem("socket_noTradechart") == "false") {
                                    //document.getElementById("error_msg").style.display = "block";
                                }
                            }
                        });
                    }
                }
                tvWidget.save(function (res) {
                    sessionStorage.setItem("activeChartChanged_noTradechart", index);
                    let chartChangeArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        if (i == index) {
                            let getLocalAutoSaveData = JSON.parse(chartSetting_noTradechart);
                            if (getLocalAutoSaveData) {
                                getLocalAutoSaveData.charts[0] = res.charts[i];
                                reqUrl.searchParams.get("searchFlag") === "true"
                                    ? sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(getLocalAutoSaveData))
                                    : localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(getLocalAutoSaveData));
                            }
                        }
                        res.charts[i].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                chartChangeArr.push(pane.sources[0].state.symbol);
                            }
                        });
                        //chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol)
                    }
                    sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(chartChangeArr));
                });
                let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"))[index]);
                await changeURLparam(reqD);
                //hiding the timeframe according to the condition
                function postMessageURLparams() {
                    var _a, _b;
                    let url = new URL(window.location);
                    let newUrlParam = url.searchParams;
                    let name = reqD === null || reqD === void 0 ? void 0 : reqD.ShortName;
                    let symbolName = reqD === null || reqD === void 0 ? void 0 : reqD.ShortName;
                    if ((reqD === null || reqD === void 0 ? void 0 : reqD.ExchType) !== "C") {
                        name += `${reqD === null || reqD === void 0 ? void 0 : reqD.Expiry}`;
                        if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) === "OPTIONS") {
                            name += `${reqD === null || reqD === void 0 ? void 0 : reqD.CPType}`;
                        }
                        if (reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) {
                            name += `${reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate.replaceAll(".00", "")}`;
                        }
                    }
                    var myObj = {
                        fullName: name,
                        exchange: getExchangeName(reqD === null || reqD === void 0 ? void 0 : reqD.Exch),
                        exchangeType: reqD === null || reqD === void 0 ? void 0 : reqD.ExchType,
                        symbol: reqD === null || reqD === void 0 ? void 0 : reqD.ShortName,
                        scripCode: reqD === null || reqD === void 0 ? void 0 : reqD.ScripCode,
                        optionType: (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "CE" || (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "PE" ? reqD === null || reqD === void 0 ? void 0 : reqD.CPType : "",
                        strikePrice: (_a = reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) !== null && _a !== void 0 ? _a : "",
                        expiry: (_b = reqD === null || reqD === void 0 ? void 0 : reqD.Expiry) !== null && _b !== void 0 ? _b : "",
                        isSearch: true,
                    };
                    return myObj;
                }
                if (browserName != "FIREFOX") {
                    window.parent.postMessage(postMessageURLparams(), window.location.ancestorOrigins[0]);
                }
                else {
                    try {
                        function getAncestorOrigins() {
                            const urls = [];
                            let parentWin = window;
                            while (parentWin !== window.top) {
                                if (parentWin.document.referrer) {
                                    try {
                                        const url = new URL(parentWin.document.referrer);
                                        urls.push(url.origin);
                                    }
                                    catch (e) { }
                                }
                                parentWin = parentWin.parent;
                            }
                            return urls;
                        }
                        let pp = getAncestorOrigins();
                        window.parent.postMessage(postMessageURLparams(), pp[0]);
                    }
                    catch (error) {
                        console.error("Error accessing parent window location:", error);
                    }
                }
                if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "EQUITY" &&
                    (reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "INDICE") {
                    try {
                        setTimeout(function () {
                            const btnArray = ["1Y", "5Y", "Max"];
                            let ddd = document
                                .getElementById("tv_chart_container")
                                .getElementsByTagName("iframe")[0]
                                .contentDocument.getElementsByTagName("body")[0]
                                .querySelector(".dateRangeExpanded-BXXUwft2");
                            let reqDivs = ddd
                                .querySelectorAll("div")[0]
                                .querySelectorAll("button");
                            reqDivs.forEach((div) => {
                                if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                    div.style.display = "none";
                                }
                            });
                        }, 1000);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
            }
        });
        window.tvWidget.subscribe("layout_changed", function (res) {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                setTimeout(() => {
                    tvWidget.save(async function (res) {
                        let resInString = JSON.stringify(res);
                        let resInterval = tvWidget.chart().resolution();
                        let activeSymbol = tvWidget.activeChart().symbol();
                        let activeLayoutName = "5Paisa";
                        let appType = "tv";
                        if (osName === "flutter") {
                            appType = isNewApp === "true" ? "newApp" : "oldApp";
                        }
                        try {
                            await postAutoSavePrefData(resInterval, activeLayoutName, activeSymbol, resInString, appType);
                        }
                        catch (error) {
                            console.error("Error saving auto-save data in api:", error);
                        }
                        localStorage.setItem("onAutoSaveNeededData", resInString);
                        if (res.layout == "s") {
                            localStorage.setItem("autoSaveStorage_Tradechart", JSON.stringify(res));
                        }
                        let chartChangeArr = [];
                        let layoutScArr = [];
                        for (let i = 0; i < res.charts.length; i++) {
                            const input = res.charts[i].panes[0].sources[0].state.symbol;
                            const parts = input.split("/")[1];
                            layoutScArr.push(parts);
                            chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol);
                        }
                        sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(chartChangeArr));
                    });
                }, 120);
            }
            else {
                setTimeout(() => {
                    tvWidget.save(async function (res) {
                        let resInString = JSON.stringify(res);
                        let resInterval = tvWidget.chart().resolution();
                        let activeSymbol = tvWidget.activeChart().symbol();
                        let activeLayoutName = "5Paisa";
                        let appType = "tv";
                        if (osName === "flutter") {
                            appType = isNewApp === "true" ? "newApp" : "oldApp";
                        }
                        try {
                            await postAutoSavePrefData(resInterval, activeLayoutName, activeSymbol, resInString, appType);
                        }
                        catch (error) {
                            console.error("Error saving auto-save data in api:", error);
                        }
                        localStorage.setItem("onAutoSaveNeededData", resInString);
                        if (res.layout == "s") {
                            reqUrl.searchParams.get("searchFlag") === "true"
                                ? sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(res))
                                : localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(res));
                            sessionStorage.removeItem("autoSaveStorageMultiLayout_noTradechart");
                        }
                        else {
                            sessionStorage.setItem("autoSaveStorageMultiLayout_noTradechart", JSON.stringify(res));
                        }
                        let chartChangeArr = [];
                        let layoutScArr = [];
                        for (let i = 0; i < res.charts.length; i++) {
                            const input = res.charts[i].panes[0].sources[0].state.symbol;
                            const parts = input.split("/")[1];
                            layoutScArr.push(parts);
                            chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol);
                        }
                        sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(chartChangeArr));
                        sessionStorage.setItem("layoutScArr_noTradechart", JSON.stringify(layoutScArr));
                    });
                }, 120);
            }
        });
        try {
            if (isTradeChartMode) {
                // Price range sync for chart 0
                chart.onVisibleRangeChanged().subscribe(null, () => {
                    try {
                        const range = tvWidget.chart(0).getPanes()[0].getMainSourcePriceScale().getVisiblePriceRange();
                        if (range)
                            priceRangeMap.set(0, { from: range.from, to: range.to });
                    }
                    catch (_) { /* ignore */ }
                });
                if (oiProfileEnabled) {
                    fetchOiDataForPane(0);
                }
                // Initialise canvas injection, tooltip, and draw loop
                const iframe = document
                    .getElementById("tv_chart_container")
                    .getElementsByTagName("iframe")[0];
                initOIProfileCanvas({
                    iframe,
                    oiDataMap,
                    oiCanvasList,
                    priceRangeMap,
                    getOiProfileEnabled: () => oiProfileEnabled,
                    getTheme: () => themeVal,
                    fetchOiDataForPane,
                    tvWidget,
                    unsubscribeDataBySubscriber,
                });
            }
        }
        catch (error) {
            console.error("Error setting up OI Profile:", error);
        }
        window.addEventListener("message", async (event) => {
            let origins = [
                "https://fno.5paisa.com",
                "https://fno-pre.5paisa.com",
                "https://fno360.5paisa.com",
                "https://tradestation-pre.5paisa.com",
                "https://ttweb.5paisa.com"
            ];
            if (origins.includes(event.origin)) {
                let receivedData = event.data;
                //temp is represent --> activechart
                let temp = sessionStorage.getItem("activeChartChanged_Tradechart");
                if (receivedData.actionType == "buysellform") {
                    sessionStorage.setItem("buySellFlag", receivedData.actionType);
                    await handleMessageEvent(event, brokerFac._handleMessageEvent);
                    // brokerFac._handleMessageEvent?.showOrderDialog ? brokerFac._handleMessageEvent.showOrderDialog(order) : () => {};
                }
                if (receivedData.actionType === "chartNavigation") {
                    let getAutoSaveData;
                    const fnoTheme = receivedData.data.theme;
                    const reqUrl = new URL(window.location);
                    const key = reqUrl.searchParams.get("isTradeChart") === "true"
                        ? "autoSaveStorage_Tradechart"
                        : "autoSaveStorage_noTradechart";
                    const urlParams = parseChartUrl(window.location.href);
                    let sessionScripCode = urlParams === null || urlParams === void 0 ? void 0 : urlParams.ScripCode;
                    if (reqUrl.searchParams.get("isTradeChart") === "false") {
                        if (fnoTheme === "dark" || fnoTheme === "Dark") {
                            setTimeout(() => {
                                tvWidget.changeTheme("Dark");
                            }, 500);
                        }
                        else if (fnoTheme === "light" || fnoTheme === "Light") {
                            setTimeout(() => {
                                tvWidget.changeTheme("Light");
                            }, 500);
                        }
                    }
                    var exChange = "NSE";
                    switch (receivedData.data.exchange) {
                        case "M":
                            exChange = "MCX";
                            break;
                        case "B":
                            exChange = "BSE";
                            break;
                        default:
                            exChange = "NSE";
                    }
                    let tickerSymbol = exChange +
                        ":" +
                        receivedData.data.fullName +
                        "/" +
                        Number(receivedData.data.scripCode) +
                        "-" +
                        receivedData.data.exchangeType;
                    window.tvWidget.activeChart().setSymbol(tickerSymbol);
                    let reqD = await AlterUrlParam(tickerSymbol);
                    await changeURLparam(reqD);
                }
                if (receivedData.actionType.includes("SENSEX searched") ||
                    receivedData.actionType.includes("BANKEX searched") ||
                    receivedData.actionType.includes("exch M")) {
                    let span_instance = document.getElementById("span_tag_PG");
                    let span_greek_div_instance = document.getElementById("span_greek_div");
                    span_greek_div_instance.style.display = "none";
                    span_instance.innerHTML = "Price";
                    sessionStorage.setItem("PriceGreek", "Price");
                }
                else {
                    let span_instance = document.getElementById("span_tag_PG");
                    let span_greek_div_instance = document.getElementById("span_greek_div");
                    span_greek_div_instance.style.display = "block";
                    if (sessionStorage.getItem("PriceGreek") == "Price") {
                        span_instance.innerHTML = "Price";
                    }
                    else {
                        span_instance.innerHTML = "Greeks";
                        sessionStorage.setItem("PriceGreek", "Greeks");
                    }
                }
            }
        });
        if (reqUrl.searchParams.get("isTradeChart") === "false" && reqUrl.searchParams.get("osName") === "flutter") {
            window.fromFlutter = async function (data) {
                let activeChartIndex = sessionStorage.getItem("activeChartChanged_noTradechart") || 0;
                let receivedData = data;
                if (sessionStorage.getItem("__lInternal") === "true") {
                    loggly_util.logAdvancedMessage("fromFlutter Data", {
                        Msg: "Data received from flutter",
                        clientCode: localStorage.getItem("ClientCode"),
                        Payload: {
                            data: receivedData.data,
                        },
                    });
                }
                const flutterTheme = receivedData.data.theme;
                if (reqUrl.searchParams.get("isTradeChart") === "false") {
                    if (flutterTheme === "night" || flutterTheme === "Night" || flutterTheme === "dark" || flutterTheme === "Dark") {
                        setTimeout(() => {
                            tvWidget.changeTheme("Dark");
                        }, 100);
                    }
                    else if (flutterTheme === "day" || flutterTheme === "Day" || flutterTheme === "light" || flutterTheme === "Light") {
                        setTimeout(() => {
                            tvWidget.changeTheme("Light");
                        }, 100);
                    }
                }
                if (receivedData.actionType === "chartNavigation") {
                    var exChange = "NSE";
                    switch (receivedData.data.exchange) {
                        case "M":
                            exChange = "MCX";
                            break;
                        case "B":
                            exChange = "BSE";
                            break;
                        default:
                            exChange = "NSE";
                    }
                    let tickerSymbol = exChange +
                        ":" +
                        receivedData.data.fullName.trim() +
                        "/" +
                        Number(receivedData.data.scripCode) +
                        "-" +
                        receivedData.data.exchangeType;
                    let onAutoSaveNeededData = JSON.parse(localStorage.getItem("onAutoSaveNeededData"));
                    let updatedAutoSaveData = updateMainSeries(onAutoSaveNeededData, tickerSymbol, receivedData.data.fullName, activeChartIndex);
                    // await window.tvWidget.load(updatedAutoSaveData);
                    if (sessionStorage.getItem("__lInternal") === "true") {
                        loggly_util.logAdvancedMessage("fromFlutter Data", {
                            Msg: "Data received from flutter",
                            clientCode: localStorage.getItem("ClientCode"),
                            ticker: tickerSymbol,
                            Payload: {
                                data: receivedData.data,
                            },
                        });
                    }
                    window.tvWidget.activeChart().setSymbol(tickerSymbol);
                    let reqD = await AlterUrlParam(tickerSymbol);
                    await changeURLparam(reqD);
                }
                else if (receivedData.actionType === "indicatorApply") {
                    tvWidget.chart().createStudy(receivedData.data.indicatorName);
                }
                else if (receivedData.actionType === "intervalApply") {
                    tvWidget.chart().setResolution(receivedData.data.interval);
                }
                else if (receivedData.actionType === "chartTypeApply") {
                    tvWidget.chart().setChartType(Number(receivedData.data.chartType));
                }
            };
        }
        //option chain button
        window.tvWidget.onContextMenu(function (unixtime, price) {
            const reqUrl = new URL(window.location);
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                return [
                    {
                        position: "top",
                        text: "Option Chain",
                        click: function () {
                            let myDivo = document.getElementById("myFrameDiv");
                            if (myDivo == null) {
                                openingOptionChain();
                            }
                        },
                    },
                ];
            }
        });
        //watchlist code
        let watchdef;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                window.watchlistApi = await tvWidget.watchList();
                watchdef = await (async () => {
                    try {
                        const mwatchNames = await getDefault();
                        // Check for duplicate watchlist names before adding
                        const existingWatchlists = mwatchNames;
                        if (!existingWatchlists.includes(mwatchNames)) {
                            return mwatchNames;
                        }
                    }
                    catch (error) {
                        // Handle errors here
                        console.error(error);
                    }
                })();
            }
        }
        changeThemeFun(themeVal, tvWidget);
        let status;
        if (localStorage.getItem("CDSL") == "true") {
            async function authData() {
                var _a, _b;
                //status?.body?.GetSellAuthorizationStatusList[0].AuthorizationStatus
                status = await getSellAuthStatus();
                if (((_a = status === null || status === void 0 ? void 0 : status.body) === null || _a === void 0 ? void 0 : _a.GetSellAuthorizationStatusList[0].AuthorizationStatus) ===
                    "Y") {
                    const dialog = document.querySelector("#auth-success");
                    dialog.showModal();
                    localStorage.removeItem("CDSL");
                    const done = document.getElementById("donebtn");
                    done.addEventListener("click", function () {
                        dialog.close();
                    });
                    let cross = document.getElementById("fc");
                    cross === null || cross === void 0 ? void 0 : cross.addEventListener("click", function () {
                        dialog === null || dialog === void 0 ? void 0 : dialog.close();
                    });
                    localStorage.removeItem("CDSL");
                }
                else if (((_b = status === null || status === void 0 ? void 0 : status.body) === null || _b === void 0 ? void 0 : _b.GetSellAuthorizationStatusList[0].AuthorizationStatus) ===
                    "N") {
                    const dialog1 = document.querySelector("#auth-failed");
                    dialog1.showModal();
                    localStorage.removeItem("CDSL");
                    const ok = document.getElementById("ok");
                    ok.addEventListener("click", function () {
                        dialog1.close();
                    });
                    let cross1 = document.getElementById("sc");
                    cross1 === null || cross1 === void 0 ? void 0 : cross1.addEventListener("click", function () {
                        dialog1 === null || dialog1 === void 0 ? void 0 : dialog1.close();
                    });
                    localStorage.removeItem("CDSL");
                }
            }
            authData();
        }
        window.tvWidget.subscribe("study", (event) => {
            sessionStorage.setItem("indicatorFlag", true);
            let ind = `${event.value}`;
            captureEvent("Top_Menu_Click", {
                ClientCode: localStorage.getItem("ClientCode"),
                Action: "Indicators",
                Script_Name: tvWidget.activeChart().symbol(),
                Selected_Indicator: ind,
                Chart_Type_Selected: "Trading View"
            });
        });
        //hiding the timeframe according to the condition
        const currentUrlParams = parseChartUrl(window.location.href);
        if ((currentUrlParams === null || currentUrlParams === void 0 ? void 0 : currentUrlParams.ExchType) != "C") {
            try {
                if (firstLoad == true) {
                    setTimeout(function () {
                        const btnArray = ["1Y", "5Y", "Max"];
                        let ddd = document
                            .getElementById("tv_chart_container")
                            .getElementsByTagName("iframe")[0]
                            .contentDocument.getElementsByTagName("body")[0]
                            .querySelector(".dateRangeExpanded-BXXUwft2");
                        let reqDivs = ddd.querySelectorAll("div")[0].querySelectorAll("button");
                        reqDivs.forEach((div) => {
                            if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                div.style.display = "none";
                            }
                        });
                    }, 1000);
                    firstLoad = false;
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        else {
            try {
                let ddd = document
                    .getElementById("tv_chart_container")
                    .getElementsByTagName("iframe")[0]
                    .contentDocument.getElementsByTagName("body")[0]
                    .querySelector(".dateRangeExpanded-BXXUwft2");
                let reqDivs = ddd.querySelectorAll("div")[0].querySelectorAll("div");
                reqDivs.forEach((div) => {
                    if ((div === null || div === void 0 ? void 0 : div.textContent) == "1Y" ||
                        (div === null || div === void 0 ? void 0 : div.textContent) == "5Y" ||
                        (div === null || div === void 0 ? void 0 : div.textContent) == "MAX") {
                        div.style.display = "flex";
                    }
                });
            }
            catch (error) {
                console.log(error);
            }
        }
        var param = new URLSearchParams(location.search);
        window.tvWidget
            .activeChart()
            .onSymbolChanged()
            .subscribe(null, async (symbol) => {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"));
                getLoadSymbl[sessionStorage.getItem("activeChartChanged_Tradechart")] =
                    !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                        ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                        : symbol.ticker;
                symbol.ticker;
                sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(getLoadSymbl));
                if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                    let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                    await changeURLparam(reqD);
                }
                else {
                    let reqD = await AlterUrlParam(symbol.ticker);
                    await changeURLparam(reqD);
                }
            }
            else {
                let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                getLoadSymbl[sessionStorage.getItem("activeChartChanged_noTradechart")] =
                    !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                        ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                        : symbol.ticker;
                symbol.ticker;
                sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(getLoadSymbl));
                if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                    let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                    await changeURLparam(reqD);
                }
                else {
                    let reqD = await AlterUrlParam(symbol.ticker);
                    await changeURLparam(reqD);
                }
            }
        });
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                if (!sessionStorage.getItem("WatchList_set")) {
                    const returnFwatchdef = watchdef.map((item) => item.MwatchName);
                    const WatchList_set = new Set(returnFwatchdef);
                    const newMap = new Map();
                    sessionStorage.setItem("WatchList_set", JSON.stringify(Array.from(WatchList_set)));
                    Promise.all(Array.from(WatchList_set).map((watch) => getDefaultSymbolNames(watch).then((symbolList) => {
                        newMap.set(watch, symbolList);
                        return watchlistApi.createList(watch, symbolList);
                    })));
                    let defaultSetWatchInterval = setInterval(() => {
                        if (watchlistApi) {
                            const existingListsObject = watchlistApi.getAllLists();
                            if (existingListsObject) {
                                const existingListsArrays = Object.values(existingListsObject);
                                // const filterdArr = existingListsArrays.filter((item) =>
                                //   ["NIFTY50", "Watchlist"].includes(item.title)
                                // );
                                for (const item of existingListsArrays) {
                                    const watchTitleFromLocalStorage = localStorage.getItem("WatchTitle");
                                    // Check if WatchTitle is undefined or null
                                    if (watchTitleFromLocalStorage === undefined ||
                                        watchTitleFromLocalStorage === null) {
                                        // Set the active list to NIFTY50
                                        if (item.title === "NIFTY50") {
                                            watchlistApi.setActiveList(item.id);
                                            item.symbols.forEach((element) => {
                                                clearInterval(defaultSetWatchInterval);
                                            });
                                        }
                                    }
                                    else {
                                        // WatchTitle is defined, set the active list based on WatchTitle
                                        if (item.title === watchTitleFromLocalStorage) {
                                            watchlistApi.setActiveList(item.id);
                                            item.symbols.forEach((element) => {
                                                clearInterval(defaultSetWatchInterval);
                                            });
                                        }
                                    }
                                    if (item.title === "Watchlist") {
                                        watchlistApi.deleteList(item.id);
                                    }
                                }
                                sessionStorage.setItem("newMap", JSON.stringify(Array.from(newMap)));
                            }
                        }
                    }, 1000);
                }
                /////////////Watchlist Remaining code
                // Flag to track if it's the first load
                if (watchlistApi) {
                    let previousSymbols = [];
                    let isFirstLoad = true;
                    watchlistApi.onListChanged().subscribe(null, async function (aa, bb) {
                        const activeListsID = watchlistApi.getActiveListId();
                        const existingListsObject = watchlistApi.getAllLists();
                        const existingListsArray = Object.values(existingListsObject);
                        previousSymbols = previousLengthHolder;
                        let globalLengthHolder = previousLengthHolder;
                        const WatchactiveList = existingListsArray.find((list) => list.id === activeListsID);
                        if (!WatchactiveList) {
                            console.error("Active List not found in the existingListsArray");
                            return;
                        }
                        const { title: Watch_title, id: activeListid, symbols: ActiveWatchListSymbols, } = WatchactiveList;
                        // Skip sorting on the first load
                        if (!isFirstLoad) {
                            if (previousSymbols === ActiveWatchListSymbols) {
                                let ActiveWatchListSymbolsList = [...ActiveWatchListSymbols];
                                ActiveWatchListSymbolsList = sortPreviousSymbols(previousSymbols);
                                watchlistApi.updateList(activeListid, ActiveWatchListSymbolsList);
                            }
                        }
                        else {
                            // Mark that the first load is done after the list is loaded
                            isFirstLoad = false;
                        }
                        if (previousSymbols.length == ActiveWatchListSymbols.length) {
                            previousSymbols = [...ActiveWatchListSymbols];
                            return;
                        }
                        const isEditable = await filterIsEditable(watchdef, Watch_title);
                        const symbolsCount = ActiveWatchListSymbols.length;
                        if (isEditable && symbolsCount <= 50) {
                            await handleWatchlistEdit(globalLengthHolder, ActiveWatchListSymbols, activeListid, Watch_title);
                        }
                        else {
                            await handleWatchlistLimit(isEditable, Watch_title, activeListid, globalLengthHolder);
                        }
                    });
                    ////////////////////////////////////
                    async function handleWatchlistEdit(globalLengthHolder, ActiveWatchListSymbols, activeListid, Watch_title) {
                        if (globalLengthHolder.length < ActiveWatchListSymbols.length) {
                            const lastElem = ActiveWatchListSymbols[ActiveWatchListSymbols.length - 1];
                            const result_after_ticker = await getExch_Exchtype_Scripcode(lastElem);
                            // Update list and save the symbol
                            await updateWatchlistAndSaveSymbol("A", Watch_title, result_after_ticker, ActiveWatchListSymbols, activeListid);
                        }
                        else {
                            let desiredSym = await findMissingValues(globalLengthHolder, ActiveWatchListSymbols);
                            const result_after_ticker = await getExch_Exchtype_Scripcode(desiredSym[0]);
                            // Update list and save the deleted symbol
                            await updateWatchlistAndSaveSymbol("D", Watch_title, result_after_ticker, ActiveWatchListSymbols, activeListid);
                        }
                    }
                    async function updateWatchlistAndSaveSymbol(action, Watch_title, ticker, ActiveWatchListSymbols, activeListid) {
                        // watchlistApi.updateList(activeListid, ActiveWatchListSymbols);
                        await saveMW(action, Watch_title, ticker.Exch, ticker.ScripCode, ticker.ExchType);
                    }
                    async function handleWatchlistLimit(isEditable, Watch_title, activeListid, globalLengthHolder) {
                        let Watch_Message = isEditable
                            ? "Max 50 symbols can be added in Watchlist"
                            : "Symbol cannot be added or deleted in Watchlist";
                        const latestArray = globalLengthHolder.map((str) => {
                            if (str.includes("searchTrue")) {
                                const [type, name, code, , Check2] = str
                                    .split(/[:/]/)
                                    .filter(Boolean);
                                return `${type}:${name}/${code}-${Check2}`;
                            }
                            return str;
                        });
                        watchlistApi.updateList(activeListid, latestArray);
                        await openCustomAlert(`${Watch_Message} ${Watch_title}`);
                    }
                    watchlistApi
                        .onActiveListChanged()
                        .subscribe(null, async function (aa, bb) {
                        const activeListsID = watchlistApi.getActiveListId();
                        const existingListsObject = watchlistApi.getAllLists();
                        const existingListsArray = Object.values(existingListsObject);
                        const WatchactiveList = existingListsArray.find((list) => list.id === activeListsID);
                        isFirstLoad = true;
                        if (WatchactiveList) {
                            let Watch_title = WatchactiveList.title;
                            localStorage.setItem("WatchTitle", Watch_title);
                        }
                        //this if else for watchlist title
                        else {
                            console.log("Active List not found in the existingListsArray");
                        }
                    });
                }
            }
        }
        if (reqUrl.searchParams.get("isTradeChart") === "false") {
            const wb = await tvWidget.widgetbar();
            wb.closeOrderPanel();
        }
    });
}
else {
    window.tvWidget.onChartReady(async () => {
        const chart = tvWidget.activeChart();
        // OI PROFILE — only initialise when isTradeChart=true
        const priceRangeMap = new Map();
        let statusDiv;
        // Calculate chart loading time
        const chartLoadEndTime = performance.now();
        const chartLoadingTime = Math.round(chartLoadEndTime - chartLoadStartTime);
        const chartLoadingTimeSeconds = (chartLoadingTime / 1000).toFixed(2);
        // Send chart loading time to CleverTap
        captureEvent("Chart_Load", {
            ClientCode: localStorage.getItem("ClientCode"),
            Script_Name: sessionStorage.getItem("load_symbols_Tradechart") || sessionStorage.getItem("load_symbols_noTradechart"),
            Chart_Loading_Time_MS: chartLoadingTime,
            Chart_Loading_Time_Seconds: chartLoadingTimeSeconds,
            Action: "Chart_Loaded_Successfully"
        });
        if (isNewApp === "true") {
            const iframe = document.getElementById("tv_chart_container").getElementsByTagName("iframe")[0];
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            statusDiv = iframeDoc.querySelector(".statusesWrapper-l31H9iuA");
            if (statusDiv)
                statusDiv.style.display = "none";
            tvWidget.applyOverrides({
                "paneProperties.legendProperties.showSeriesTitle": false,
                "paneProperties.legendProperties.showSeriesOHLC": true,
                "paneProperties.legendProperties.showStudyTitles": true,
                "paneProperties.legendProperties.showStudyValues": true,
                "paneProperties.legendProperties.showBarChange": false,
            });
        }
        else {
            if (statusDiv)
                statusDiv.style.display = "block";
            tvWidget.applyOverrides({
                "paneProperties.legendProperties.showSeriesTitle": true,
                "paneProperties.legendProperties.showSeriesOHLC": true,
                "paneProperties.legendProperties.showStudyTitles": true,
                "paneProperties.legendProperties.showStudyValues": true,
                "paneProperties.legendProperties.showBarChange": true,
            });
        }
        let checkUnsubscribeSocket;
        document.addEventListener("visibilitychange", function (event) {
            if (document.hidden) {
                checkUnsubscribeSocket = setTimeout(() => {
                    const allLayoutSymbols = new Set();
                    for (let i = 0; i < window.tvWidget.chartsCount(); i++) {
                        const { ScripCode } = getExch_Exchtype_Scripcode(tvWidget.chart(i).symbolExt().ticker);
                        if (ScripCode) {
                            allLayoutSymbols.add(ScripCode);
                        }
                    }
                    onFocusChange(false, [...allLayoutSymbols]);
                }, 25000);
            }
            else {
                if (checkUnsubscribeSocket) {
                    clearTimeout(checkUnsubscribeSocket);
                    checkUnsubscribeSocket = null;
                }
                onFocusChange(true);
            }
        });
        const reqUrl = new URL(window.location);
        try {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                if (reqUrl.searchParams.get("searchFlag") === "true") {
                    let urlParams = parseChartUrl(window.location.href);
                    let exchangeAutoSave = (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Exch.toUpperCase()) === "N"
                        ? "NSE"
                        : (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Exch.toUpperCase()) === "B"
                            ? "BSE"
                            : "MCX";
                    let redicted_sym = `${exchangeAutoSave}:${ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName}/${ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode}-${ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ExchType}`;
                    const getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorage_noTradechart" + (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode))) === null
                        ? JSON.parse(localStorage.getItem("autoSaveStorage_noTradechart" + (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode)))
                        : JSON.parse(sessionStorage.getItem("autoSaveStorage_noTradechart" + (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode)));
                    if (getAutoSaveData) {
                        tvWidget.load(getAutoSaveData);
                        reqUrl.searchParams.get("searchFlag") === "true" ?
                            sessionStorage.setItem("reso" + sessionScripCode, getAutoSaveData.charts[0].panes[0].sources[0].state.interval) :
                            localStorage.setItem("reso", getAutoSaveData.charts[0].panes[0].sources[0].state.interval);
                        var url = new URL(window.location.href);
                        let params = new URLSearchParams(url.search);
                        params.delete("searchFlag");
                        const updatedUrl = `${url.origin}${url.pathname}?${params.toString()}`;
                        window.history.pushState({}, "", updatedUrl);
                    }
                }
                else if (reqUrl.searchParams.has("ispopOutRedirection")) {
                    let newurls = new URL(window.location);
                    let getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                    if (newurls.searchParams.has("ispopOut"))
                        getAutoSaveData = JSON.parse(localStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                    if (getAutoSaveData) {
                        tvWidget.load(getAutoSaveData);
                        async function changeURLByAutoSave(name) {
                            let reqD = await AlterUrlParam(name);
                            await changeURLparam(reqD);
                        }
                        getAutoSaveData.charts[0].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                pane.sources[0].state.symbol = reqSymbol;
                                pane.sources[0].state.shortName =
                                    ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName.trim();
                                changeURLByAutoSave(pane.sources[0].state.symbol);
                                sessionStorage.setItem("reso" + sessionScripCode, pane.sources[0].state.interval);
                            }
                        });
                    }
                    newurls.searchParams.delete("ispopOutRedirection");
                    window.history.pushState({}, "", newurls);
                }
                else if (sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart") != null) {
                    const getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                    tvWidget.load(getAutoSaveData);
                    getAutoSaveData.charts[0].panes.forEach((pane) => {
                        if (pane.sources[0].type === "MainSeries") {
                            pane.sources[0].state.symbol = reqSymbol;
                            pane.sources[0].state.shortName =
                                ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName.trim();
                            changeURLByAutoSave(pane.sources[0].state.symbol);
                            sessionStorage.setItem("reso" + sessionScripCode, pane.sources[0].state.interval);
                        }
                    });
                    sessionStorage.setItem("isMultiLayOut", "true");
                    sessionStorage.setItem("reso" + sessionScripCode, getAutoSaveData.charts[0].panes[0].sources[0].state.interval);
                }
                else {
                    let newurls = new URL(window.location);
                    let getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                    if (newurls.searchParams.has("ispopOut"))
                        getAutoSaveData = JSON.parse(localStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                    if (getAutoSaveData &&
                        (osName === "flutter" || (osName !== "flutter" && sessionStorage.getItem("indicatorFlag") != null))) {
                        tvWidget.load(getAutoSaveData);
                        async function changeURLByAutoSave(name) {
                            let reqD = await AlterUrlParam(name);
                            await changeURLparam(reqD);
                        }
                        getAutoSaveData.charts[0].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                pane.sources[0].state.symbol = reqSymbol;
                                pane.sources[0].state.shortName =
                                    pane.sources[0].state.shortName =
                                        ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName.trim();
                                changeURLByAutoSave(pane.sources[0].state.symbol);
                                sessionStorage.setItem("reso" + sessionScripCode, pane.sources[0].state.interval);
                            }
                        });
                    }
                }
                //Comes from expanded button for multilayout
                try {
                    const raw = localStorage.getItem("autoSaveStorageMultiLayout_noTradechart");
                    const miniViewGetAutoSaveData = raw ? JSON.parse(raw) : null;
                    if (miniViewGetAutoSaveData) {
                        tvWidget.load(miniViewGetAutoSaveData);
                        localStorage.removeItem("autoSaveStorageMultiLayout_noTradechart");
                    }
                }
                catch (err) {
                    console.error("Failed to load Multlayout layout Data: ", err);
                }
            }
            else {
                if (reqUrl.searchParams.get("searchFlag") === "true") {
                    if (sessionStorage.getItem("autoSaveStorageMultiLayout_noTradechart") !=
                        undefined) {
                        const getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_noTradechart"));
                        tvWidget.load(getAutoSaveData);
                        reqUrl.searchParams.get("searchFlag") === "true" ?
                            sessionStorage.setItem("reso" + sessionScripCode, getAutoSaveData.charts[0].panes[0].sources[0].state.interval) :
                            localStorage.setItem("reso", getAutoSaveData.charts[0].panes[0].sources[0].state.interval);
                    }
                    else {
                        const getAutoSaveData = JSON.parse(reqUrl.searchParams.get("searchFlag") === "true" ?
                            sessionStorage.getItem("autoSaveStorage_noTradechart" + sessionScripCode) :
                            localStorage.getItem("autoSaveStorage_noTradechart"));
                        if (getAutoSaveData) {
                            tvWidget.load(getAutoSaveData);
                            reqUrl.searchParams.get("searchFlag") === "true" ?
                                sessionStorage.setItem("reso" + sessionScripCode, getAutoSaveData.charts[0].panes[0].sources[0].state.interval) :
                                localStorage.setItem("reso", getAutoSaveData.charts[0].panes[0].sources[0].state.interval);
                        }
                    }
                }
                else {
                    // Prefer multi-layout autosave for noTradechart if available
                    const multiLayoutStr = sessionStorage.getItem("autoSaveStorageMultiLayout_noTradechart");
                    const getAutoSaveData = multiLayoutStr
                        ? JSON.parse(multiLayoutStr)
                        : JSON.parse(reqUrl.searchParams.get("searchFlag") === "true"
                            ? sessionStorage.getItem("autoSaveStorage_noTradechart" + sessionScripCode)
                            : localStorage.getItem("autoSaveStorage_noTradechart"));
                    let newurls = new URL(window.location);
                    let redicted_sym = (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.Exch) +
                        ":" +
                        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ShortName) +
                        "/" +
                        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ScripCode) +
                        "-" +
                        (ScripInfoDetails === null || ScripInfoDetails === void 0 ? void 0 : ScripInfoDetails.ExchType);
                    if (getAutoSaveData &&
                        (osName === "flutter" || (osName !== "flutter" && sessionStorage.getItem("indicatorFlag") != null))) {
                        ///loading previous data here after refresh in miniview
                        let layoutType = localStorage.getItem("prevLayout");
                        if (layoutType === "s") {
                            const data = sessionStorage.getItem("prevDataForMiniView");
                            if (data) {
                                try {
                                    const parsedData = JSON.parse(data);
                                    if (parsedData) {
                                        tvWidget.load(parsedData);
                                        console.log("Loaded prevDataForMiniView into tvWidget");
                                    }
                                    else {
                                        console.warn("prevDataForMiniView parsed to null, skipping load");
                                    }
                                }
                                catch (err) {
                                    console.error("Failed to parse prevDataForMiniView:", err);
                                }
                            }
                            else {
                                console.log("No prevDataForMiniView found in sessionStorage");
                            }
                        }
                        else {
                            tvWidget.load(getAutoSaveData);
                        }
                        //restore symbol on dashboard symbol change
                        let ScripInfoDetailsNew;
                        try {
                            ScripInfoDetailsNew = await getScripInfoData(paramsForScripInfo);
                        }
                        catch (error) {
                            ScripInfoDetailsNew = null;
                        }
                        var exChangeNew = "NSE";
                        switch (ScripInfoDetailsNew === null || ScripInfoDetailsNew === void 0 ? void 0 : ScripInfoDetailsNew.Exch) {
                            case "M":
                                exChangeNew = "MCX";
                                break;
                            case "B":
                                exChangeNew = "BSE";
                                break;
                            default:
                                exChangeNew = "NSE";
                        }
                        let tickerSymbolNew = exChangeNew +
                            ":" +
                            (ScripInfoDetailsNew === null || ScripInfoDetailsNew === void 0 ? void 0 : ScripInfoDetailsNew.Name) +
                            "/" +
                            Number(ScripInfoDetailsNew === null || ScripInfoDetailsNew === void 0 ? void 0 : ScripInfoDetailsNew.ScripCode) +
                            "-" +
                            (ScripInfoDetailsNew === null || ScripInfoDetailsNew === void 0 ? void 0 : ScripInfoDetailsNew.ExchType);
                        window.tvWidget.activeChart().setSymbol(tickerSymbolNew);
                        const restoredInterval = getAutoSaveData.charts[0].panes[0].sources[0].state.interval;
                        if (reqUrl.searchParams.get("searchFlag") === "true") {
                            sessionStorage.setItem("reso" + sessionScripCode, restoredInterval);
                        }
                        else {
                            localStorage.setItem("reso", restoredInterval);
                        }
                    }
                }
            }
        }
        catch (_a) {
            console.log("autosave causing probelm");
        }
        // To track the last known state of the tab
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                observeTabChanges(brokerFac);
            }
        }
        async function changeURLByAutoSave(name) {
            let reqD = await AlterUrlParam(name);
            await changeURLparam(reqD);
        }
        tvWidget.subscribe("onAutoSaveNeeded", function (res) {
            sessionStorage.setItem("indicatorFlag", true);
            tvWidget.save(async function (res) {
                if (reqUrl.searchParams.get("isTradeChart") === "true") {
                    if (res.layout === "s") {
                        res.charts[0].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                let sym = pane.sources[0].state.symbol;
                                let scripCode = sym.split("/")[1].split("-")[0];
                                changeURLByAutoSave(pane.sources[0].state.symbol);
                                sessionStorage.setItem("reso" + sessionScripCode, pane.sources[0].state.interval);
                                sessionStorage.setItem("autoSaveStorage_Tradechart" + scripCode, JSON.stringify(res));
                                localStorage.setItem("autoSaveStorage_Tradechart" + scripCode, JSON.stringify(res));
                            }
                        });
                        if (sessionStorage.autoSaveStorageMultiLayout_Tradechart)
                            sessionStorage.removeItem("autoSaveStorageMultiLayout_Tradechart");
                    }
                    else {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_Tradechart", JSON.stringify(res));
                        setTimeout(myFun, 0, res);
                        function myFun(res) {
                            for (let i = 0; i < res.charts.length; i++) {
                                var new_res;
                                res.charts[i].panes.forEach((pane) => {
                                    if (pane.sources[0].type === "MainSeries") {
                                        let sym = pane.sources[0].state.symbol;
                                        let scripCode = sym.split("/")[1].split("-")[0];
                                        new_res = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                                        new_res.charts = [
                                            JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart")).charts[i],
                                        ];
                                        new_res.layout = "s";
                                        localStorage.setItem("autoSaveStorage_Tradechart" + scripCode, JSON.stringify(new_res));
                                    }
                                });
                            }
                        }
                    }
                }
                else {
                    if (res.layout == "s") {
                        reqUrl.searchParams.get("searchFlag") === "true"
                            ? sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(res))
                            : localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(res));
                        sessionStorage.setItem("prevDataForMiniView", JSON.stringify(res));
                        sessionStorage.removeItem("autoSaveStorageMultiLayout_noTradechart");
                    }
                    else {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_noTradechart", JSON.stringify(res));
                    }
                }
            });
        });
        window.tvWidget.subscribe("layout_about_to_be_changed", async function (LayoutType) {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                if (LayoutType != "s") {
                    sessionStorage.setItem("isMultiLayOut_Tradechart", "true");
                }
                else {
                    sessionStorage.setItem("isMultiLayOut_Tradechart", "false");
                }
                try {
                    let dd = document
                        .getElementById("tv_chart_container")
                        .getElementsByTagName("iframe")[0]
                        .contentDocument.getElementsByTagName("body")[0]
                        .querySelector(".chart-gui-wrapper")
                        .querySelector("#parentBuySell");
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") == "true") {
                        dd.style.display = "none";
                    }
                    else {
                        dd.style.display = "block";
                    }
                }
                catch (error) {
                    // console.log(error);
                }
                window.tvWidget.save(async function (res) {
                    sessionStorage.setItem("LayoutType_Tradechart", LayoutType);
                    // sessionStorage.setItem("isMultiLayOut_Tradechart", "true"); //need to check this so commenetd 
                    if (reqUrl.searchParams.get("isTradeChart") === "false") {
                        localStorage.setItem("prevLayout", LayoutType);
                    }
                    let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"))[sessionStorage.getItem("activeChartChanged_Tradechart")]);
                    await changeURLparam(reqD);
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") == "true" &&
                        sessionStorage.getItem("chartContentFlag_Tradechart") != "true") {
                        var symbolInfoDataa = JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"));
                        if (checkingLayoutType(LayoutType) > symbolInfoDataa.length) {
                            var lenn = checkingLayoutType(LayoutType) - symbolInfoDataa.length;
                            for (let i = 0; i < lenn; i++) {
                                symbolInfoDataa.push(symbolInfoDataa[symbolInfoDataa.length - 1]);
                            }
                            sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(symbolInfoDataa));
                        }
                        else {
                            var newarrr = [];
                            for (let i = 0; i < checkingLayoutType(LayoutType); i++) {
                                newarrr.push(symbolInfoDataa[i]);
                            }
                            sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(newarrr));
                        }
                    }
                });
            }
            else {
                if (LayoutType != "s") {
                    sessionStorage.setItem("isMultiLayOut_noTradechart", "true");
                    tvWidget.save(function (res) {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_noTradechart", JSON.stringify(res));
                    });
                }
                else {
                    if (reqUrl.searchParams.get("searchFlag") === "true")
                        sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(res));
                }
                try {
                    let dd = document
                        .getElementById("tv_chart_container")
                        .getElementsByTagName("iframe")[0]
                        .contentDocument.getElementsByTagName("body")[0]
                        .querySelector(".chart-gui-wrapper")
                        .querySelector("#parentBuySell");
                    if (sessionStorage.getItem("isMultiLayOut_noTradechart") == "true") {
                        dd.style.display = "none";
                    }
                    else {
                        dd.style.display = "block";
                    }
                }
                catch (error) {
                    // console.log(error);
                }
                tvWidget.save(async function (res) {
                    sessionStorage.setItem("LayoutType_noTradechart", LayoutType);
                    sessionStorage.setItem("isMultiLayOut_noTradechart", "true");
                    let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"))[sessionStorage.getItem("activeChartChanged_noTradechart")]);
                    await changeURLparam(reqD);
                    if (sessionStorage.getItem("isMultiLayOut_noTradechart") == "true" &&
                        sessionStorage.getItem("chartContentFlag_noTradechart") != "true") {
                        var symbolInfoDataa = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                        if (checkingLayoutType(LayoutType) > symbolInfoDataa.length) {
                            var lenn = checkingLayoutType(LayoutType) - symbolInfoDataa.length;
                            for (let i = 0; i < lenn; i++) {
                                symbolInfoDataa.push(symbolInfoDataa[symbolInfoDataa.length - 1]);
                            }
                            sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(symbolInfoDataa));
                        }
                        else {
                            var newarrr = [];
                            for (let i = 0; i < checkingLayoutType(LayoutType); i++) {
                                newarrr.push(symbolInfoDataa[i]);
                            }
                            sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(newarrr));
                        }
                    }
                });
            }
        });
        window.tvWidget.subscribe("activeChartChanged", async function (index) {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                for (let i = 0; i < window.tvWidget.chartsCount(); i++) {
                    if (i == index) {
                        window.tvWidget.activeChart();
                    }
                }
                window.tvWidget.save(function (res) {
                    sessionStorage.setItem("activeChartChanged_Tradechart", index);
                    let chartChangeArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        if (i == index) {
                            let getLocalAutoSaveData = chartSetting_Tradechart;
                            if (getLocalAutoSaveData) {
                                getLocalAutoSaveData.charts[0] = res.charts[i];
                                sessionStorage.setItem("autoSaveStorage_Tradechart" + sessionScripCode, JSON.stringify(getLocalAutoSaveData));
                            }
                        }
                        res.charts[i].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                chartChangeArr.push(pane.sources[0].state.symbol);
                            }
                        });
                    }
                    sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(chartChangeArr));
                });
                let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"))[index]);
                await changeURLparam(reqD);
                //hiding the timeframe according to the condition
                function postMessageURLparams() {
                    var _a, _b;
                    let url = new URL(window.location);
                    let newUrlParam = url.searchParams;
                    let name = `${reqD === null || reqD === void 0 ? void 0 : reqD.ShortName}`;
                    let symbolName = `${reqD === null || reqD === void 0 ? void 0 : reqD.ShortName}`;
                    if ((reqD === null || reqD === void 0 ? void 0 : reqD.ExchType) !== "C") {
                        name += `${reqD === null || reqD === void 0 ? void 0 : reqD.Expiry}`;
                        if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) === "OPTIONS") {
                            name += ` ${reqD === null || reqD === void 0 ? void 0 : reqD.CPType}`;
                        }
                        if (reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) {
                            name += ` ${reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate.replaceAll(".00", "")}`;
                        }
                    }
                    var myObj = {
                        fullName: name,
                        exchange: getExchangeName(reqD === null || reqD === void 0 ? void 0 : reqD.Exch),
                        exchangeType: reqD === null || reqD === void 0 ? void 0 : reqD.ExchType,
                        symbol: reqD === null || reqD === void 0 ? void 0 : reqD.ShortName,
                        scripCode: reqD === null || reqD === void 0 ? void 0 : reqD.ScripCode,
                        optionType: (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "CE" || (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "PE" ? reqD === null || reqD === void 0 ? void 0 : reqD.CPType : "",
                        strikePrice: (_a = reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) !== null && _a !== void 0 ? _a : "",
                        expiry: (_b = reqD === null || reqD === void 0 ? void 0 : reqD.Expiry) !== null && _b !== void 0 ? _b : "",
                        isSearch: true,
                    };
                    return myObj;
                }
                window.parent.postMessage(postMessageURLparams(), window.location.ancestorOrigins[0]);
                if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "EQUITY" &&
                    (reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "INDICE") {
                    try {
                        setTimeout(function () {
                            const btnArray = ["1Y", "5Y", "Max"];
                            let ddd = document
                                .getElementById("tv_chart_container")
                                .getElementsByTagName("iframe")[0]
                                .contentDocument.getElementsByTagName("body")[0]
                                .querySelector(".dateRangeExpanded-BXXUwft2");
                            let reqDivs = ddd
                                .querySelectorAll("div")[0]
                                .querySelectorAll("button");
                            reqDivs.forEach((div) => {
                                if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                    div.style.display = "none";
                                }
                            });
                        }, 1000);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
            }
            else {
                for (let i = 0; i < tvWidget.chartsCount(); i++) {
                    if (i == index) {
                        tvWidget
                            .activeChart()
                            .onIntervalChanged()
                            .subscribe(null, (interval, timeframeObj) => {
                            if (interval == "1D") {
                                var allSym = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                                let newA = [];
                                for (let i = 0; i < allSym.length; i++) {
                                    let matches = allSym[i].split("/")[1];
                                    newA.push(matches);
                                }
                                sessionStorage.setItem("layoutScArr_noTradechart", JSON.stringify(newA));
                            }
                            Datafeed.urlParameter.searchFlag === "true"
                                ? sessionStorage.setItem("reso" + sessionScripCode, interval)
                                : localStorage.setItem("reso", interval);
                            var feedLength = localStorage.getItem("length");
                            if (Datafeed.urlParameter.type == "futures" ||
                                Datafeed.urlParameter.type == "options" ||
                                Datafeed.urlParameter.type == "options-curcom" ||
                                Datafeed.urlParameter.type == "future-curcom" ||
                                Datafeed.urlParameter.type == "Future-curcom") {
                                if ([
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "10",
                                    "15",
                                    "30",
                                    "60",
                                    "240",
                                ].includes(interval)) {
                                    if (localStorage.getItem("intraDaydata_noTradechart") > 0 &&
                                        localStorage.getItem("socket_noTradechart") == "false") {
                                        //document.getElementById("error_msg").style.display = "none";
                                    }
                                }
                                else if (feedLength == 0 &&
                                    localStorage.getItem("socket_noTradechart") == "false") {
                                    //document.getElementById("error_msg").style.display = "block";
                                }
                            }
                        });
                    }
                }
                tvWidget.save(function (res) {
                    sessionStorage.setItem("activeChartChanged_noTradechart", index);
                    let chartChangeArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        if (i == index) {
                            let getLocalAutoSaveData = JSON.parse(chartSetting_noTradechart);
                            if (getLocalAutoSaveData) {
                                getLocalAutoSaveData.charts[0] = res.charts[i];
                                reqUrl.searchParams.get("searchFlag") === "true"
                                    ? sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(getLocalAutoSaveData))
                                    : localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(getLocalAutoSaveData));
                            }
                        }
                        res.charts[i].panes.forEach((pane) => {
                            if (pane.sources[0].type === "MainSeries") {
                                chartChangeArr.push(pane.sources[0].state.symbol);
                            }
                        });
                        //chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol)
                    }
                    sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(chartChangeArr));
                });
                let reqD = await AlterUrlParam(JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"))[index]);
                await changeURLparam(reqD);
                //hiding the timeframe according to the condition
                function postMessageURLparams() {
                    var _a, _b;
                    let url = new URL(window.location);
                    let newUrlParam = url.searchParams;
                    let name = reqD === null || reqD === void 0 ? void 0 : reqD.ShortName;
                    let symbolName = reqD === null || reqD === void 0 ? void 0 : reqD.ShortName;
                    if ((reqD === null || reqD === void 0 ? void 0 : reqD.ExchType) !== "C") {
                        name += `${reqD === null || reqD === void 0 ? void 0 : reqD.Expiry}`;
                        if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) === "OPTIONS") {
                            name += `${reqD === null || reqD === void 0 ? void 0 : reqD.CPType}`;
                        }
                        if (reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) {
                            name += `${reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate.replaceAll(".00", "")}`;
                        }
                    }
                    var myObj = {
                        fullName: name,
                        exchange: getExchangeName(reqD === null || reqD === void 0 ? void 0 : reqD.Exch),
                        exchangeType: reqD === null || reqD === void 0 ? void 0 : reqD.ExchType,
                        symbol: reqD === null || reqD === void 0 ? void 0 : reqD.ShortName,
                        scripCode: reqD === null || reqD === void 0 ? void 0 : reqD.ScripCode,
                        optionType: (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "CE" || (reqD === null || reqD === void 0 ? void 0 : reqD.CPType) == "PE" ? reqD === null || reqD === void 0 ? void 0 : reqD.CPType : "",
                        strikePrice: (_a = reqD === null || reqD === void 0 ? void 0 : reqD.StrikeRate) !== null && _a !== void 0 ? _a : "",
                        expiry: (_b = reqD === null || reqD === void 0 ? void 0 : reqD.Expiry) !== null && _b !== void 0 ? _b : "",
                        isSearch: true,
                    };
                    return myObj;
                }
                if (browserName != "FIREFOX") {
                    window.parent.postMessage(postMessageURLparams(), window.location.ancestorOrigins[0]);
                }
                else {
                    try {
                        function getAncestorOrigins() {
                            const urls = [];
                            let parentWin = window;
                            while (parentWin !== window.top) {
                                if (parentWin.document.referrer) {
                                    try {
                                        const url = new URL(parentWin.document.referrer);
                                        urls.push(url.origin);
                                    }
                                    catch (e) { }
                                }
                                parentWin = parentWin.parent;
                            }
                            return urls;
                        }
                        let pp = getAncestorOrigins();
                        window.parent.postMessage(postMessageURLparams(), pp[0]);
                    }
                    catch (error) {
                        console.error("Error accessing parent window location:", error);
                    }
                }
                if ((reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "EQUITY" &&
                    (reqD === null || reqD === void 0 ? void 0 : reqD.InstrumentType) != "INDICE") {
                    try {
                        setTimeout(function () {
                            const btnArray = ["1Y", "5Y", "Max"];
                            let ddd = document
                                .getElementById("tv_chart_container")
                                .getElementsByTagName("iframe")[0]
                                .contentDocument.getElementsByTagName("body")[0]
                                .querySelector(".dateRangeExpanded-BXXUwft2");
                            let reqDivs = ddd
                                .querySelectorAll("div")[0]
                                .querySelectorAll("button");
                            reqDivs.forEach((div) => {
                                if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                    div.style.display = "none";
                                }
                            });
                        }, 1000);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
            }
        });
        window.tvWidget.subscribe("layout_changed", function (res) {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                window.tvWidget.save(function (res) {
                    if (res.layout == "s") {
                        localStorage.setItem("autoSaveStorage_Tradechart", JSON.stringify(res));
                    }
                    let chartChangeArr = [];
                    let layoutScArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        const input = res.charts[i].panes[0].sources[0].state.symbol;
                        const parts = input.split("/")[1];
                        layoutScArr.push(parts);
                        chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol);
                    }
                    sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(chartChangeArr));
                    // sessionStorage.setItem("layoutScArr", JSON.stringify(layoutScArr));
                });
            }
            else {
                tvWidget.save(function (res) {
                    if (res.layout == "s") {
                        reqUrl.searchParams.get("searchFlag") === "true"
                            ? sessionStorage.setItem("autoSaveStorage_noTradechart" + sessionScripCode, JSON.stringify(res))
                            : localStorage.setItem("autoSaveStorage_noTradechart", JSON.stringify(res));
                        sessionStorage.setItem("prevDataForMiniView", JSON.stringify(res));
                        sessionStorage.removeItem("autoSaveStorageMultiLayout_noTradechart");
                    }
                    else {
                        sessionStorage.setItem("autoSaveStorageMultiLayout_noTradechart", JSON.stringify(res));
                    }
                    let chartChangeArr = [];
                    let layoutScArr = [];
                    for (let i = 0; i < res.charts.length; i++) {
                        const input = res.charts[i].panes[0].sources[0].state.symbol;
                        const parts = input.split("/")[1];
                        layoutScArr.push(parts);
                        chartChangeArr.push(res.charts[i].panes[0].sources[0].state.symbol);
                    }
                    sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(chartChangeArr));
                    sessionStorage.setItem("layoutScArr_noTradechart", JSON.stringify(layoutScArr));
                });
            }
        });
        try {
            if (isTradeChartMode) {
                // Price range sync for chart 0
                chart.onVisibleRangeChanged().subscribe(null, () => {
                    try {
                        const range = tvWidget.chart(0).getPanes()[0].getMainSourcePriceScale().getVisiblePriceRange();
                        if (range)
                            priceRangeMap.set(0, { from: range.from, to: range.to });
                    }
                    catch (_) { /* ignore */ }
                });
                if (oiProfileEnabled) {
                    fetchOiDataForPane(0);
                }
                // Initialise canvas injection, tooltip, and draw loop
                const iframe = document.getElementById("tv_chart_container").getElementsByTagName("iframe")[0];
                initOIProfileCanvas({
                    iframe,
                    oiDataMap,
                    oiCanvasList,
                    priceRangeMap,
                    getOiProfileEnabled: () => oiProfileEnabled,
                    getTheme: () => themeVal,
                    fetchOiDataForPane,
                    tvWidget,
                    unsubscribeDataBySubscriber,
                });
            }
        }
        catch (error) {
            console.error("Error setting up OI Profile:", error);
        }
        window.addEventListener("message", async (event) => {
            let origins = [
                "https://fno.5paisa.com",
                "https://fno-pre.5paisa.com",
                "https://fno360.5paisa.com",
                "https://tradestation-pre.5paisa.com",
                "https://ttweb.5paisa.com"
            ];
            if (origins.includes(event.origin)) {
                let receivedData = event.data;
                //temp is represent --> activechart
                let temp = sessionStorage.getItem("activeChartChanged_Tradechart");
                if (receivedData.actionType == "buysellform") {
                    sessionStorage.setItem("buySellFlag", receivedData.actionType);
                    await handleMessageEvent(event, brokerFac._handleMessageEvent);
                    // brokerFac._handleMessageEvent?.showOrderDialog ? brokerFac._handleMessageEvent.showOrderDialog(order) : () => {};
                }
                if (receivedData.actionType === "chartNavigation") {
                    let getAutoSaveData;
                    const fnoTheme = receivedData.data.theme;
                    const reqUrl = new URL(window.location);
                    const key = reqUrl.searchParams.get("isTradeChart") === "true"
                        ? "autoSaveStorage_Tradechart"
                        : "autoSaveStorage_noTradechart";
                    const urlParams = parseChartUrl(window.location.href);
                    let sessionScripCode = urlParams === null || urlParams === void 0 ? void 0 : urlParams.ScripCode;
                    if (reqUrl.searchParams.get("isTradeChart") === "false") {
                        if (fnoTheme === "dark" || fnoTheme === "Dark") {
                            setTimeout(() => {
                                tvWidget.changeTheme("Dark");
                            }, 500);
                        }
                        else if (fnoTheme === "light" || fnoTheme === "Light") {
                            setTimeout(() => {
                                tvWidget.changeTheme("Light");
                            }, 500);
                        }
                    }
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") != null &&
                        sessionStorage.getItem("isMultiLayOut_Tradechart") == "true") {
                        getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                        // temp = sessionStorage.getItem("activeChartChanged_Tradechart");
                        sessionStorage.setItem("autoSaveStorageMultiLayout_Tradechart", JSON.stringify(getAutoSaveData));
                    }
                    else {
                        if (sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode) != null) {
                            getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                        }
                        else {
                            getAutoSaveData = JSON.parse(localStorage.getItem(key));
                        }
                    }
                    if (getAutoSaveData == null || getAutoSaveData == undefined) {
                        getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                    }
                    var exChange = "NSE";
                    switch (receivedData.data.exchange) {
                        case "M":
                            exChange = "MCX";
                            break;
                        case "B":
                            exChange = "BSE";
                            break;
                        default:
                            exChange = "NSE";
                    }
                    let tickerSymbol = exChange +
                        ":" +
                        receivedData.data.fullName +
                        "/" +
                        Number(receivedData.data.scripCode) +
                        "-" +
                        receivedData.data.exchangeType;
                    if (getAutoSaveData && Array.isArray(getAutoSaveData.charts)) {
                        if (temp === null || temp === undefined) {
                            temp = 0;
                        }
                        const activeChartPane = getAutoSaveData.charts[temp];
                        if (activeChartPane && Array.isArray(activeChartPane.panes)) {
                            // Loop through panes and sources
                            activeChartPane.panes.forEach((pane, paneIndex) => {
                                var _a;
                                if (Array.isArray(pane.sources) && ((_a = pane.sources[0]) === null || _a === void 0 ? void 0 : _a.state)) {
                                    pane.sources[0].state.symbol = tickerSymbol;
                                }
                            });
                        }
                        else {
                            console.warn("No panes found in activeChart", activeChart);
                        }
                    }
                    else {
                        console.warn("getAutoSaveData or charts not available", getAutoSaveData);
                    }
                    window.tvWidget.activeChart().setSymbol(tickerSymbol);
                    let reqD = await AlterUrlParam(tickerSymbol);
                    await changeURLparam(reqD);
                }
                if (receivedData.actionType.includes("SENSEX searched") ||
                    receivedData.actionType.includes("BANKEX searched") ||
                    receivedData.actionType.includes("exch M")) {
                    let span_instance = document.getElementById("span_tag_PG");
                    let span_greek_div_instance = document.getElementById("span_greek_div");
                    span_greek_div_instance.style.display = "none";
                    span_instance.innerHTML = "Price";
                    sessionStorage.setItem("PriceGreek", "Price");
                }
                else {
                    let span_instance = document.getElementById("span_tag_PG");
                    let span_greek_div_instance = document.getElementById("span_greek_div");
                    span_greek_div_instance.style.display = "block";
                    if (sessionStorage.getItem("PriceGreek") == "Price") {
                        span_instance.innerHTML = "Price";
                    }
                    else {
                        span_instance.innerHTML = "Greeks";
                        sessionStorage.setItem("PriceGreek", "Greeks");
                    }
                }
            }
        });
        if (reqUrl.searchParams.get("isTradeChart") === "false" && reqUrl.searchParams.get("osName") === "flutter") {
            window.fromFlutter = async function (data) {
                let temp = sessionStorage.getItem("activeChartChanged_Tradechart");
                let receivedData = data;
                if (sessionStorage.getItem("__lInternal") === "true") {
                    loggly_util.logAdvancedMessage("fromFlutter Data", {
                        Msg: "Data received from flutter",
                        clientCode: localStorage.getItem("ClientCode"),
                        Payload: {
                            data: receivedData.data,
                        },
                    });
                }
                const flutterTheme = receivedData.data.theme;
                if (reqUrl.searchParams.get("isTradeChart") === "false") {
                    if (flutterTheme === "night" || flutterTheme === "Night" || flutterTheme === "dark" || flutterTheme === "Dark") {
                        setTimeout(() => {
                            tvWidget.changeTheme("Dark");
                        }, 100);
                    }
                    else if (flutterTheme === "day" || flutterTheme === "Day" || flutterTheme === "light" || flutterTheme === "Light") {
                        setTimeout(() => {
                            tvWidget.changeTheme("Light");
                        }, 100);
                    }
                }
                if (receivedData.actionType === "chartNavigation") {
                    let getAutoSaveData;
                    const reqUrl = new URL(window.location);
                    const key = reqUrl.searchParams.get("isTradeChart") === "true"
                        ? "autoSaveStorage_Tradechart"
                        : "autoSaveStorage_noTradechart";
                    const urlParams = parseChartUrl(window.location.href);
                    let sessionScripCode = urlParams === null || urlParams === void 0 ? void 0 : urlParams.ScripCode;
                    if (sessionStorage.getItem("isMultiLayOut_Tradechart") != null &&
                        sessionStorage.getItem("isMultiLayOut_Tradechart") == "true") {
                        getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                        sessionStorage.setItem("autoSaveStorageMultiLayout_Tradechart", JSON.stringify(getAutoSaveData));
                    }
                    else {
                        if (sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode) != null) {
                            getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorage_Tradechart" + sessionScripCode));
                        }
                        else {
                            getAutoSaveData = JSON.parse(localStorage.getItem(key));
                        }
                    }
                    if (getAutoSaveData == null || getAutoSaveData == undefined) {
                        getAutoSaveData = JSON.parse(sessionStorage.getItem("autoSaveStorageMultiLayout_Tradechart"));
                    }
                    var exChange = "NSE";
                    switch (receivedData.data.exchange) {
                        case "M":
                            exChange = "MCX";
                            break;
                        case "B":
                            exChange = "BSE";
                            break;
                        default:
                            exChange = "NSE";
                    }
                    let tickerSymbol = exChange +
                        ":" +
                        receivedData.data.fullName.trim() +
                        "/" +
                        Number(receivedData.data.scripCode) +
                        "-" +
                        receivedData.data.exchangeType;
                    if (temp === null || temp === undefined) {
                        temp = 0;
                    }
                    if (sessionStorage.getItem("__lInternal") === "true") {
                        loggly_util.logAdvancedMessage("fromFlutter Data", {
                            Msg: "Data received from flutter",
                            clientCode: localStorage.getItem("ClientCode"),
                            ticker: tickerSymbol,
                            Payload: {
                                data: receivedData.data,
                            },
                        });
                    }
                    getAutoSaveData.charts[temp].panes[0].sources[0].state.symbol =
                        tickerSymbol;
                    getAutoSaveData.charts[temp].panes[0].sources[0].state.shortName =
                        receivedData.data.fullName.trim();
                    await window.tvWidget.load(getAutoSaveData);
                    // window.tvWidget.activeChart().setSymbol(tickerSymbol);
                    let reqD = await AlterUrlParam(tickerSymbol);
                    await changeURLparam(reqD);
                }
            };
        }
        //option chain button
        window.tvWidget.onContextMenu(function (unixtime, price) {
            const reqUrl = new URL(window.location);
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                return [
                    {
                        position: "top",
                        text: "Option Chain",
                        click: function () {
                            let myDivo = document.getElementById("myFrameDiv");
                            if (myDivo == null) {
                                openingOptionChain();
                            }
                        },
                    },
                ];
            }
        });
        //watchlist code
        let watchdef;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                window.watchlistApi = await tvWidget.watchList();
                watchdef = await (async () => {
                    try {
                        const mwatchNames = await getDefault();
                        // Check for duplicate watchlist names before adding
                        const existingWatchlists = mwatchNames;
                        if (!existingWatchlists.includes(mwatchNames)) {
                            return mwatchNames;
                        }
                    }
                    catch (error) {
                        // Handle errors here
                        console.error(error);
                    }
                })();
            }
        }
        changeThemeFun(themeVal, tvWidget);
        let status;
        if (localStorage.getItem("CDSL") == "true") {
            async function authData() {
                var _a, _b;
                //status?.body?.GetSellAuthorizationStatusList[0].AuthorizationStatus
                status = await getSellAuthStatus();
                if (((_a = status === null || status === void 0 ? void 0 : status.body) === null || _a === void 0 ? void 0 : _a.GetSellAuthorizationStatusList[0].AuthorizationStatus) ===
                    "Y") {
                    const dialog = document.querySelector("#auth-success");
                    dialog.showModal();
                    localStorage.removeItem("CDSL");
                    const done = document.getElementById("donebtn");
                    done.addEventListener("click", function () {
                        dialog.close();
                    });
                    let cross = document.getElementById("fc");
                    cross === null || cross === void 0 ? void 0 : cross.addEventListener("click", function () {
                        dialog === null || dialog === void 0 ? void 0 : dialog.close();
                    });
                    localStorage.removeItem("CDSL");
                }
                else if (((_b = status === null || status === void 0 ? void 0 : status.body) === null || _b === void 0 ? void 0 : _b.GetSellAuthorizationStatusList[0].AuthorizationStatus) ===
                    "N") {
                    const dialog1 = document.querySelector("#auth-failed");
                    dialog1.showModal();
                    localStorage.removeItem("CDSL");
                    const ok = document.getElementById("ok");
                    ok.addEventListener("click", function () {
                        dialog1.close();
                    });
                    let cross1 = document.getElementById("sc");
                    cross1 === null || cross1 === void 0 ? void 0 : cross1.addEventListener("click", function () {
                        dialog1 === null || dialog1 === void 0 ? void 0 : dialog1.close();
                    });
                    localStorage.removeItem("CDSL");
                }
            }
            authData();
        }
        window.tvWidget.subscribe("study", (event) => {
            sessionStorage.setItem("indicatorFlag", true);
            let ind = `${event.value}`;
            captureEvent("Top_Menu_Click", {
                ClientCode: localStorage.getItem("ClientCode"),
                Action: "Indicators",
                Script_Name: sessionStorage.getItem("load_symbols"),
                Selected_Indicator: ind,
            });
        });
        //hiding the timeframe according to the condition
        const currentUrlParams = parseChartUrl(window.location.href);
        if ((currentUrlParams === null || currentUrlParams === void 0 ? void 0 : currentUrlParams.ExchType) != "C") {
            try {
                if (firstLoad == true) {
                    setTimeout(function () {
                        const btnArray = ["1Y", "5Y", "Max"];
                        let ddd = document
                            .getElementById("tv_chart_container")
                            .getElementsByTagName("iframe")[0]
                            .contentDocument.getElementsByTagName("body")[0]
                            .querySelector(".dateRangeExpanded-BXXUwft2");
                        let reqDivs = ddd.querySelectorAll("div")[0].querySelectorAll("button");
                        reqDivs.forEach((div) => {
                            if ((div === null || div === void 0 ? void 0 : div.ariaLabel) && btnArray.includes(div === null || div === void 0 ? void 0 : div.ariaLabel)) {
                                div.style.display = "none";
                            }
                        });
                    }, 1000);
                    firstLoad = false;
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        else {
            try {
                let ddd = document
                    .getElementById("tv_chart_container")
                    .getElementsByTagName("iframe")[0]
                    .contentDocument.getElementsByTagName("body")[0]
                    .querySelector(".dateRangeExpanded-BXXUwft2");
                let reqDivs = ddd.querySelectorAll("div")[0].querySelectorAll("div");
                reqDivs.forEach((div) => {
                    if ((div === null || div === void 0 ? void 0 : div.textContent) == "1Y" ||
                        (div === null || div === void 0 ? void 0 : div.textContent) == "5Y" ||
                        (div === null || div === void 0 ? void 0 : div.textContent) == "MAX") {
                        div.style.display = "flex";
                    }
                });
            }
            catch (error) {
                console.log(error);
            }
        }
        var param = new URLSearchParams(location.search);
        window.tvWidget
            .activeChart()
            .onSymbolChanged()
            .subscribe(null, async (symbol) => {
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_Tradechart"));
                getLoadSymbl[sessionStorage.getItem("activeChartChanged_Tradechart")] =
                    !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                        ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                        : symbol.ticker;
                symbol.ticker;
                sessionStorage.setItem("load_symbols_Tradechart", JSON.stringify(getLoadSymbl));
                if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                    let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                    await changeURLparam(reqD);
                }
                else {
                    let reqD = await AlterUrlParam(symbol.ticker);
                    await changeURLparam(reqD);
                }
            }
            else {
                let getLoadSymbl = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                getLoadSymbl[sessionStorage.getItem("activeChartChanged_noTradechart")] =
                    !symbol.ticker.includes("-") && !symbol.ticker.includes("/")
                        ? `${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`
                        : symbol.ticker;
                symbol.ticker;
                sessionStorage.setItem("load_symbols_noTradechart", JSON.stringify(getLoadSymbl));
                if (!symbol.ticker.includes("-") && !symbol.ticker.includes("/")) {
                    let reqD = await AlterUrlParam(`${symbol.ticker}/${symbol.scripCode}-${symbol.exchType}`);
                    await changeURLparam(reqD);
                }
                else {
                    let reqD = await AlterUrlParam(symbol.ticker);
                    await changeURLparam(reqD);
                }
            }
        });
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            if (Datafeed.urlParameter.ispopOut !== "true") {
                if (!sessionStorage.getItem("WatchList_set")) {
                    const returnFwatchdef = watchdef.map((item) => item.MwatchName);
                    const WatchList_set = new Set(returnFwatchdef);
                    const newMap = new Map();
                    sessionStorage.setItem("WatchList_set", JSON.stringify(Array.from(WatchList_set)));
                    Promise.all(Array.from(WatchList_set).map((watch) => getDefaultSymbolNames(watch).then((symbolList) => {
                        newMap.set(watch, symbolList);
                        return watchlistApi.createList(watch, symbolList);
                    })));
                    let defaultSetWatchInterval = setInterval(() => {
                        if (watchlistApi) {
                            const existingListsObject = watchlistApi.getAllLists();
                            if (existingListsObject) {
                                const existingListsArrays = Object.values(existingListsObject);
                                // const filterdArr = existingListsArrays.filter((item) =>
                                //   ["NIFTY50", "Watchlist"].includes(item.title)
                                // );
                                for (const item of existingListsArrays) {
                                    const watchTitleFromLocalStorage = localStorage.getItem("WatchTitle");
                                    // Check if WatchTitle is undefined or null
                                    if (watchTitleFromLocalStorage === undefined ||
                                        watchTitleFromLocalStorage === null) {
                                        // Set the active list to NIFTY50
                                        if (item.title === "NIFTY50") {
                                            watchlistApi.setActiveList(item.id);
                                            item.symbols.forEach((element) => {
                                                clearInterval(defaultSetWatchInterval);
                                            });
                                        }
                                    }
                                    else {
                                        // WatchTitle is defined, set the active list based on WatchTitle
                                        if (item.title === watchTitleFromLocalStorage) {
                                            watchlistApi.setActiveList(item.id);
                                            item.symbols.forEach((element) => {
                                                clearInterval(defaultSetWatchInterval);
                                            });
                                        }
                                    }
                                    if (item.title === "Watchlist") {
                                        watchlistApi.deleteList(item.id);
                                    }
                                }
                                sessionStorage.setItem("newMap", JSON.stringify(Array.from(newMap)));
                            }
                        }
                    }, 1000);
                }
                /////////////Watchlist Remaining code
                // Flag to track if it's the first load
                if (watchlistApi) {
                    let previousSymbols = [];
                    let isFirstLoad = true;
                    watchlistApi.onListChanged().subscribe(null, async function (aa, bb) {
                        const activeListsID = watchlistApi.getActiveListId();
                        const existingListsObject = watchlistApi.getAllLists();
                        const existingListsArray = Object.values(existingListsObject);
                        previousSymbols = previousLengthHolder;
                        let globalLengthHolder = previousLengthHolder;
                        const WatchactiveList = existingListsArray.find((list) => list.id === activeListsID);
                        if (!WatchactiveList) {
                            console.error("Active List not found in the existingListsArray");
                            return;
                        }
                        const { title: Watch_title, id: activeListid, symbols: ActiveWatchListSymbols, } = WatchactiveList;
                        // Skip sorting on the first load
                        if (!isFirstLoad) {
                            if (previousSymbols === ActiveWatchListSymbols) {
                                let ActiveWatchListSymbolsList = [...ActiveWatchListSymbols];
                                ActiveWatchListSymbolsList = sortPreviousSymbols(previousSymbols);
                                watchlistApi.updateList(activeListid, ActiveWatchListSymbolsList);
                            }
                        }
                        else {
                            // Mark that the first load is done after the list is loaded
                            isFirstLoad = false;
                        }
                        if (previousSymbols.length == ActiveWatchListSymbols.length) {
                            previousSymbols = [...ActiveWatchListSymbols];
                            return;
                        }
                        const isEditable = await filterIsEditable(watchdef, Watch_title);
                        const symbolsCount = ActiveWatchListSymbols.length;
                        if (isEditable && symbolsCount <= 50) {
                            await handleWatchlistEdit(globalLengthHolder, ActiveWatchListSymbols, activeListid, Watch_title);
                        }
                        else {
                            await handleWatchlistLimit(isEditable, Watch_title, activeListid, globalLengthHolder);
                        }
                    });
                    ////////////////////////////////////
                    async function handleWatchlistEdit(globalLengthHolder, ActiveWatchListSymbols, activeListid, Watch_title) {
                        if (globalLengthHolder.length < ActiveWatchListSymbols.length) {
                            const lastElem = ActiveWatchListSymbols[ActiveWatchListSymbols.length - 1];
                            const result_after_ticker = await getExch_Exchtype_Scripcode(lastElem);
                            // Update list and save the symbol
                            await updateWatchlistAndSaveSymbol("A", Watch_title, result_after_ticker, ActiveWatchListSymbols, activeListid);
                        }
                        else {
                            let desiredSym = await findMissingValues(globalLengthHolder, ActiveWatchListSymbols);
                            const result_after_ticker = await getExch_Exchtype_Scripcode(desiredSym[0]);
                            // Update list and save the deleted symbol
                            await updateWatchlistAndSaveSymbol("D", Watch_title, result_after_ticker, ActiveWatchListSymbols, activeListid);
                        }
                    }
                    async function updateWatchlistAndSaveSymbol(action, Watch_title, ticker, ActiveWatchListSymbols, activeListid) {
                        // watchlistApi.updateList(activeListid, ActiveWatchListSymbols);
                        await saveMW(action, Watch_title, ticker.Exch, ticker.ScripCode, ticker.ExchType);
                    }
                    async function handleWatchlistLimit(isEditable, Watch_title, activeListid, globalLengthHolder) {
                        let Watch_Message = isEditable
                            ? "Max 50 symbols can be added in Watchlist"
                            : "Symbol cannot be added or deleted in Watchlist";
                        const latestArray = globalLengthHolder.map((str) => {
                            if (str.includes("searchTrue")) {
                                const [type, name, code, , Check2] = str
                                    .split(/[:/]/)
                                    .filter(Boolean);
                                return `${type}:${name}/${code}-${Check2}`;
                            }
                            return str;
                        });
                        watchlistApi.updateList(activeListid, latestArray);
                        await openCustomAlert(`${Watch_Message} ${Watch_title}`);
                    }
                    watchlistApi
                        .onActiveListChanged()
                        .subscribe(null, async function (aa, bb) {
                        const activeListsID = watchlistApi.getActiveListId();
                        const existingListsObject = watchlistApi.getAllLists();
                        const existingListsArray = Object.values(existingListsObject);
                        const WatchactiveList = existingListsArray.find((list) => list.id === activeListsID);
                        isFirstLoad = true;
                        if (WatchactiveList) {
                            let Watch_title = WatchactiveList.title;
                            localStorage.setItem("WatchTitle", Watch_title);
                        }
                        //this if else for watchlist title
                        else {
                            console.log("Active List not found in the existingListsArray");
                        }
                    });
                }
            }
        }
        if (reqUrl.searchParams.get("isTradeChart") === "false") {
            const wb = await tvWidget.widgetbar();
            wb.closeOrderPanel();
        }
    });
}
if (window.tvWidget.headerReady) {
    window.tvWidget.headerReady().then(function () {
        var _a;
        const reqUrl = new URL(window.location);
        window.tvWidget
            .activeChart()
            .onIntervalChanged()
            .subscribe(null, (interval, timeframeObj) => {
            sessionStorage.setItem("indicatorFlag", true);
            window.layoutMap.clear();
            if (reqUrl.searchParams.get("isTradeChart") === "true") {
                if (localStorage.getItem("intervalClickCounts") === null) {
                    localStorage.setItem("intervalClickCounts", JSON.stringify({}));
                }
                function updateClickCount(interval) {
                    const intervalClickCounts = JSON.parse(localStorage.getItem("intervalClickCounts"));
                    // Increment the count for the selected interval
                    if (intervalClickCounts[interval]) {
                        intervalClickCounts[interval] += 1;
                    }
                    else {
                        intervalClickCounts[interval] = 1;
                    }
                    localStorage.setItem("intervalClickCounts", JSON.stringify(intervalClickCounts));
                    return intervalClickCounts[interval];
                }
                const selectedTenure = localStorage.getItem("tradingview.chart.lastUsedTimeBasedResolution") === null
                    ? "1"
                    : localStorage.getItem("tradingview.chart.lastUsedTimeBasedResolution");
                const clickCount = updateClickCount(interval);
                //CleverTap event logging
                captureEvent("Interval_Menu_Click", {
                    ClientCode: localStorage.getItem("ClientCode"),
                    Action: "Tenure",
                    interval: interval,
                    Selected_Tenure: selectedTenure,
                    Script_Name: tvWidget.activeChart().symbol(),
                    ClickCount: clickCount,
                });
                var lastClose;
                localStorage.setItem("reso", interval);
                var feedLength = localStorage.getItem("length");
            }
            else {
                if (interval == "1D") {
                    var allSym = JSON.parse(sessionStorage.getItem("load_symbols_noTradechart"));
                    let newA = [];
                    for (let i = 0; i < allSym.length; i++) {
                        let matches = allSym[i].split("/")[1];
                        newA.push(matches);
                    }
                    sessionStorage.setItem("layoutScArr_noTradechart", JSON.stringify(newA));
                }
                Datafeed.urlParameter.searchFlag === "true"
                    ? sessionStorage.setItem("reso" + sessionScripCode, interval)
                    : localStorage.setItem("reso", interval);
                var feedLength = localStorage.getItem("length");
                if (Datafeed.urlParameter.type == "futures" ||
                    Datafeed.urlParameter.type == "options" ||
                    Datafeed.urlParameter.type == "options-curcom" ||
                    Datafeed.urlParameter.type == "future-curcom" ||
                    Datafeed.urlParameter.type == "Future-curcom") {
                    if ([
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "10",
                        "15",
                        "30",
                        "60",
                        "240",
                    ].includes(interval)) {
                        if (localStorage.getItem("intraDaydata_noTradechart") > 0 &&
                            localStorage.getItem("socket_noTradechart") == "false") {
                        }
                    }
                    else if (feedLength == 0 &&
                        localStorage.getItem("socket_noTradechart") == "false") {
                    }
                }
            }
        });
        window.tvWidget
            .activeChart()
            .onChartTypeChanged()
            .subscribe(null, (chartType) => {
            let chart_type;
            switch (chartType) {
                case 0:
                    chart_type = "Bars";
                    break;
                case 1:
                    chart_type = "Candles";
                    break;
                case 9:
                    chart_type = "Hollow Candles";
                    break;
                case 13:
                    chart_type = "Columns";
                    break;
                case 2:
                    chart_type = "Line";
                    break;
                case 14:
                    chart_type = "Line with markers";
                    break;
                case 15:
                    chart_type = "Step Line";
                    break;
                case 3:
                    chart_type = "Area";
                    break;
                case 16:
                    chart_type = "HLC Area";
                    break;
                case 10:
                    chart_type = "Baseline ";
                    break;
                case 12:
                    chart_type = "High-low";
                    break;
                case 8:
                    chart_type = "Heikin-Ashi";
                    break;
                case 4:
                    chart_type = "Renko";
                    break;
                case 7:
                    chart_type = "Line break";
                    break;
                case 5:
                    chart_type = "Kagi";
                    break;
                case 6:
                    chart_type = "Point $ figure";
                    break;
            }
            captureEvent("Top_Menu_Click", {
                ClientCode: localStorage.getItem("ClientCode"),
                Action: "Chart_type",
                Script_Name: tvWidget.activeChart().symbol(),
                Selected_Chart: chart_type,
                Chart_Type_Selected: "Trading View"
            });
        });
        //OI Profile Toggle button — only shown when isTradeChart=true
        if (isTradeChartMode) {
            const oiProfileButton = window.tvWidget.createButton({ align: "left" });
            oiProfileButton.id = "oiProfileToggle";
            oiProfileButton.setAttribute("title", "Toggle OI Profile");
            const oiWrapper = document.createElement("span");
            oiWrapper.className = `oi-wrapper ${themeVal === "dark" ? "dark" : "light"}`;
            const oiCheckbox = document.createElement("span");
            oiCheckbox.className = "oi-checkbox";
            const oiCheckmark = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            oiCheckmark.setAttribute("width", "9");
            oiCheckmark.setAttribute("height", "7");
            oiCheckmark.setAttribute("viewBox", "0 0 9 7");
            oiCheckmark.setAttribute("fill", "none");
            oiCheckmark.classList.add("oi-checkmark");
            const oiPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
            oiPath.setAttribute("d", "M1 3L3.5 5.5L8 1");
            oiPath.setAttribute("stroke", "white");
            oiPath.setAttribute("stroke-width", "1.5");
            oiPath.setAttribute("stroke-linecap", "round");
            oiPath.setAttribute("stroke-linejoin", "round");
            oiCheckmark.appendChild(oiPath);
            oiCheckbox.appendChild(oiCheckmark);
            const oiLabel = document.createElement("span");
            oiLabel.textContent = "OI Profile";
            oiWrapper.appendChild(oiCheckbox);
            oiWrapper.appendChild(oiLabel);
            oiProfileButton.appendChild(oiWrapper);
            // Set initial button state using imported helper
            updateOIProfileButton(oiCheckbox, oiProfileEnabled, themeVal);
            oiProfileButton.addEventListener("click", () => {
                var _a, _b;
                oiProfileEnabled = !oiProfileEnabled;
                localStorage.setItem(OI_PROFILE_STORAGE_KEY, String(oiProfileEnabled));
                setOIProfileVisibility(oiCanvasList, oiProfileEnabled);
                updateOIProfileButton(oiCheckbox, oiProfileEnabled, themeVal);
                if (oiProfileEnabled) {
                    try {
                        const count = window.tvWidget.chartsCount();
                        for (let i = 0; i < count; i++) {
                            try {
                                const sym = tvWidget.chart(i).symbol();
                                fetchOiDataForPane(i, sym);
                            }
                            catch (_) {
                                console.log(`[OI Profile] Fetching pane ${i} (no symbol)`);
                                fetchOiDataForPane(i);
                            }
                        }
                    }
                    catch (err) {
                        console.warn("[OI Profile] Error fetching on enable:", err);
                    }
                }
                else {
                    // Unsubscribe from all OI websocket feeds and clear data when disabling
                    try {
                        const count = window.tvWidget.chartsCount();
                        for (let i = 0; i < count; i++) {
                            console.log(`[OI Profile] Unsubscribing oi_profile_pane_${i}`);
                            unsubscribeDataBySubscriber(`oi_profile_pane_${i}`);
                        }
                    }
                    catch (err) {
                        console.warn("[OI Profile] Error unsubscribing:", err);
                    }
                    oiDataMap.clear();
                    // Hide tooltip immediately
                    try {
                        const iframeEl = (_a = document.getElementById("tv_chart_container")) === null || _a === void 0 ? void 0 : _a.getElementsByTagName("iframe")[0];
                        const iDoc = (iframeEl === null || iframeEl === void 0 ? void 0 : iframeEl.contentDocument) || ((_b = iframeEl === null || iframeEl === void 0 ? void 0 : iframeEl.contentWindow) === null || _b === void 0 ? void 0 : _b.document);
                        const tip = iDoc === null || iDoc === void 0 ? void 0 : iDoc.getElementById("oi-tooltip");
                        if (tip) {
                            tip.style.display = "none";
                        }
                    }
                    catch (err) {
                        console.warn("[OI Profile] Error hiding tooltip:", err);
                    }
                }
            });
        }
        //Fund button
        let fundsButton;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            fundsButton = window.tvWidget.createButton({ align: "right" });
            fundsButton.id = "funds";
            fundsButton.setAttribute("title", "Funds");
            if (themeVal === "dark") {
                fundsButton.classList.add("fundsIconDark");
            }
            else {
                fundsButton.classList.add("fundsIcon");
            }
            fundsButton.addEventListener("click", () => {
                window.open("https://ttweb.5paisa.com/ssofund?redirect=https://tv.5paisa.com/", "_blank");
            });
        }
        let expandChartsButton;
        if (reqUrl.searchParams.get("isTradeChart") === "false" && osName !== "flutter") {
            expandChartsButton = window.tvWidget.createButton({ align: "right" });
            expandChartsButton.id = "expandCharts";
            expandChartsButton.setAttribute("title", "Expand");
            if (themeVal === "dark") {
                expandChartsButton.classList.add("maximizeIcon");
            }
            else {
                expandChartsButton.classList.add("maximizeIcon");
            }
            expandChartsButton.addEventListener("click", async () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
                if (sessionStorage.getItem("__cInternal") === "true") {
                    let isExpandIcon = true;
                    let symbolInput;
                    const layout = JSON.parse(localStorage.getItem("onAutoSaveNeededData"));
                    symbolInput = (_g = (_f = (_e = (_d = (_c = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.charts) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.panes) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.sources) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.state) === null || _g === void 0 ? void 0 : _g.symbol;
                    if (!symbolInput) {
                        symbolInput = window.tvWidget.activeChart().symbol();
                    }
                    const symbolDetails = await AlterUrlParam(symbolInput);
                    const urlObj = await changeURLparam(symbolDetails, isExpandIcon);
                    const newUrl = new URL(urlObj);
                    // Updating parameters
                    if (newUrl.searchParams.has("isTradeChart"))
                        newUrl.searchParams.set("isTradeChart", "true");
                    if (newUrl.searchParams.has("searchFlag"))
                        newUrl.searchParams.set("searchFlag", "true");
                    if (newUrl.searchParams.has("theme"))
                        newUrl.searchParams.delete("theme");
                    const updatedUrl = newUrl.toString();
                    window.open(`${updatedUrl}`, "_blank");
                }
                else {
                    const multiStr = sessionStorage.getItem("autoSaveStorageMultiLayout_noTradechart");
                    const singleStr = sessionStorage.getItem("autoSaveStorage_noTradechart" + sessionScripCode) || localStorage.getItem("autoSaveStorage_noTradechart");
                    let isExpandIcon = true;
                    let symbolInput;
                    if (multiStr) {
                        localStorage.setItem("autoSaveStorageMultiLayout_noTradechart", multiStr);
                        try {
                            const layout = JSON.parse(multiStr);
                            symbolInput = (_p = (_o = (_m = (_l = (_k = (_j = (_h = layout === null || layout === void 0 ? void 0 : layout.charts) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.panes) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.sources) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.state) === null || _p === void 0 ? void 0 : _p.symbol;
                        }
                        catch (_x) { }
                    }
                    else if (singleStr) {
                        try {
                            const layout = JSON.parse(singleStr);
                            symbolInput = (_w = (_v = (_u = (_t = (_s = (_r = (_q = layout === null || layout === void 0 ? void 0 : layout.charts) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.panes) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.sources) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.state) === null || _w === void 0 ? void 0 : _w.symbol;
                        }
                        catch (_y) { }
                    }
                    if (!symbolInput) {
                        // Fallback to active chart symbol
                        symbolInput = window.tvWidget.activeChart().symbol();
                    }
                    const symbolDetails = await AlterUrlParam(symbolInput);
                    const urlObj = await changeURLparam(symbolDetails, isExpandIcon);
                    const newUrl = new URL(urlObj);
                    // Updating parameters
                    if (newUrl.searchParams.has("isTradeChart"))
                        newUrl.searchParams.set("isTradeChart", "true");
                    if (newUrl.searchParams.has("searchFlag"))
                        newUrl.searchParams.set("searchFlag", "true");
                    if (newUrl.searchParams.has("theme"))
                        newUrl.searchParams.delete("theme");
                    const updatedUrl = newUrl.toString();
                    window.open(`${updatedUrl}`, "_blank");
                }
            });
        }
        // Product Buttons
        let productsButton;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            productsButton = window.tvWidget.createButton({ align: "right" });
            productsButton.id = "products";
            const productsSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            productsSvg.setAttribute("width", "14");
            productsSvg.setAttribute("height", "14");
            productsSvg.setAttribute("viewBox", "0 0 20 20");
            productsSvg.setAttribute("fill", "none");
            const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
            const clipPath = document.createElementNS("http://www.w3.org/2000/svg", "clipPath");
            clipPath.setAttribute("id", "productsClip");
            const clipRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            clipRect.setAttribute("width", "20");
            clipRect.setAttribute("height", "20");
            clipRect.setAttribute("fill", "white");
            clipPath.appendChild(clipRect);
            defs.appendChild(clipPath);
            productsSvg.appendChild(defs);
            const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
            group.setAttribute("clip-path", "url(#productsClip)");
            const svgPaths = [
                "M6.667 7.5C6.667 7.279 6.755 7.067 6.911 6.911C7.067 6.754 7.279 6.667 7.5 6.667H12.5C12.721 6.667 12.933 6.754 13.09 6.911C13.246 7.067 13.333 7.279 13.333 7.5V12.5C13.333 12.721 13.246 12.933 13.09 13.09C12.933 13.246 12.721 13.333 12.5 13.333H7.5C7.279 13.333 7.067 13.246 6.911 13.09C6.755 12.933 6.667 12.721 6.667 12.5V7.5Z",
                "M2.5 6.667H3.333",
                "M2.5 13.333H3.333",
                "M6.667 2.5V3.333",
                "M13.333 2.5V3.333",
                "M16.667 6.667H17.5",
                "M16.667 13.333H17.5",
                "M6.667 16.667V17.5",
                "M13.333 16.667V17.5",
            ];
            svgPaths.forEach((d) => {
                const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                path.setAttribute("d", d);
                path.setAttribute("stroke", "white");
                path.setAttribute("stroke-width", "1.667");
                path.setAttribute("stroke-linecap", "round");
                path.setAttribute("stroke-linejoin", "round");
                group.appendChild(path);
            });
            productsSvg.appendChild(group);
            const productsText = document.createElement("span");
            productsText.innerText = "Products";
            productsButton.appendChild(productsSvg);
            productsButton.appendChild(productsText);
            productsButton.classList.add("productsIcon");
            initProductsPopup(productsButton, themeVal, localStorage.getItem("ClientCode") || undefined);
        }
        //Popout button
        let popOut;
        if (!reqUrl.searchParams.has("ispopOut") &&
            reqUrl.searchParams.get("isTradeChart") === "true") {
            popOut = window.tvWidget.createButton({ align: "left" });
            popOut.id = "popOut";
            popOut.setAttribute("title", "Open in New Tab");
            if (themeVal == "dark") {
                popOut.classList.add("popoutIconDark");
            }
            else {
                popOut.classList.add("popoutIcon");
            }
            popOut.addEventListener("click", () => {
                var url = new URL(window.location);
                url.searchParams.set("searchFlag", "false");
                window.open(`${window.location.href}&ispopOut=true&ispopOutRedirection=true`, "_blank");
            });
        }
        //options chain button
        let optionsChainButton;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            optionsChainButton = window.tvWidget.createButton({ align: "left" });
            optionsChainButton.classList.add("optionsChain");
            optionsChainButton.setAttribute("title", "Option Chain");
            if (themeVal === "night" || themeVal === "dark") {
                optionsChainButton.classList.add("optionsChainDark");
                optionsChainButton.classList.remove("optionsChain");
            }
            else {
                optionsChainButton.classList.remove("optionsChainDark");
                optionsChainButton.classList.add("optionsChain");
            }
            optionsChainButton.addEventListener("click", () => {
                let myDivFrmHeader = document.getElementById("myFrameDiv");
                if (myDivFrmHeader == null) {
                    openingOptionChain();
                }
            });
        }
        let marketDepthButton;
        let isDialogOpening = false;
        function debounce(func, wait) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        }
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            marketDepthButton = window.tvWidget.createButton({ align: "left" });
            marketDepthButton.classList.add("marketDepthIcon");
            marketDepthButton.setAttribute("title", "Market Depth");
            if (themeVal === "night" || themeVal === "dark") {
                marketDepthButton.classList.add("marketDepthIconDark");
                marketDepthButton.classList.remove("marketDepthIcon");
            }
            else {
                marketDepthButton.classList.remove("marketDepthIconDark");
                marketDepthButton.classList.add("marketDepthIcon");
            }
            const debouncedOpenDialog = debounce(() => {
                if (isDialogOpening)
                    return;
                isDialogOpening = true;
                const symbol = window.tvWidget.activeChart().symbol();
                openMarketDepthDropDown(symbol, 'fromTopBtn').finally(() => {
                    isDialogOpening = false;
                });
            }, 300);
            marketDepthButton.addEventListener("click", (event) => {
                event.stopPropagation();
                debouncedOpenDialog();
            });
        }
        let username = localStorage.getItem("ClientName");
        if (username.length > 8) {
            username = username.substring(0, 8) + "...";
        }
        var radioLight = document.getElementById("light");
        var radioDark = document.getElementById("dark");
        let logOut;
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            logOut = window.tvWidget.createButton({ align: "right" });
            logOut.innerHTML = `<svg width="127" height="50" >
      <path transform="translate(0.1,9) scale(1.5)" d="M9.99951 10.625C11.553 10.625 12.812 9.36562 12.812 7.8125C12.812 6.25938 11.5542 5 9.99951 5C8.44482 5 7.18701 6.25781 7.18701 7.8125C7.18701 9.36719 8.44482 10.625 9.99951 10.625ZM11.2495 12.5H8.74951C6.89248 12.5 5.32998 13.6672 4.69873 15.3012C6.05811 16.6602 7.93311 17.5 9.99951 17.5C12.0659 17.5 13.9409 16.659 15.3003 15.3012C14.6675 13.668 13.105 12.5 11.2495 12.5Z" fill="#E31B54"/>
      <path transform="translate(0.1,9) scale(1.5)" d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 5C11.5535 5 12.8125 6.25938 12.8125 7.8125C12.8125 9.36563 11.5547 10.625 10 10.625C8.44687 10.625 7.1875 9.36563 7.1875 7.8125C7.1875 6.25938 8.44531 5 10 5ZM10 17.5C7.93242 17.5 6.05859 16.659 4.69922 15.3012C5.33203 13.668 6.89453 12.5 8.75 12.5H11.25C13.107 12.5 14.6695 13.6672 15.3008 15.3012C13.9414 16.6602 12.0664 17.5 10 17.5Z" fill="#FECCD6"/>
      <text x="40" y="21" font-family="Arial" font-size="13" font-weight="bold" >${username}</text>
      <text x="40" y="37" font-family="Arial" font-size="12" text-anchor-"middle" >${localStorage.getItem("ClientCode")}</text>
      <path transform="translate(115,22)" d="M6.3569 6.8407L10.8524 1.94025C11.0492 1.72522 11.0492 1.37684 10.8524 1.16127C10.6556 0.946243 10.3359 0.946243 10.139 1.16127L6.00025 5.67302L1.86147 1.16181C1.66464 0.946786 1.34494 0.946786 1.14762 1.16181C0.950793 1.37684 0.950793 1.72577 1.14762 1.94079L5.6431 6.84124C5.83789 7.05301 6.16261 7.05301 6.3569 6.8407Z" fill="#0080FF" stroke="#0080FF" stroke-width="0.6"/>
      </svg>`;
            logOut.addEventListener("click", function () {
                if (drop.style.display === "none" || drop.style.display === "") {
                    drop.style.display = "block";
                }
                else {
                    drop.style.display = "none";
                }
            }, { passive: true });
        }
        let drop = document.createElement("div");
        drop.id = "dropdown";
        if (themeVal == "dark") {
            drop.style.background = "#1e222d";
            drop.style.color = "#d1d4dc";
        }
        else {
            drop.style.background = "#fff";
            drop.style.color = "#131722";
        }
        drop.style.position = "absolute";
        drop.style.top = "45px";
        drop.style.right = "10px";
        drop.style.display = "none";
        drop.style.padding = "5px 0";
        drop.style.boxShadow = "0 2px 4px #0003";
        drop.style.width = "187px";
        drop.innerHTML = `
    <div id="themeTray" class="menuitem" style="margin: 0 15px; border-bottom:1px solid #d1d4dc; text-align:center; ">Change Theme</div>
    <div id="orderTray" class="menuitem" style="margin: 0 15px; border-bottom:1px solid #d1d4dc; text-align:center; ">Order Setting</div>
    <div id="transactionTray" class="menuitem" style="margin: 0 15px; border-bottom:1px solid #d1d4dc; display: flex; align-items: center; justify-content: space-between; padding: 10px 0;">
        <button id="transactionButton">Transaction On Charts</button>
        <div class="toggle-wrapper">
            <label class="switch">
                <input type="checkbox" id="transactionToggle"  />
                <span class="slider"></span>
            </label>
        </div>
    </div>
    <button id="logoutTray" class="" style="text-align:center; color:#1570ef;border:1px solid #1570ef; background-color:transparent; margin:10px auto; display:flex;border-radius:2px; min-width:148px; text-align:center;justify-content:center;padding:8px 10px; ">Logout</button>
   `;
        document.getElementById("tv_chart_container").appendChild(drop);
        document
            .getElementById("logoutTray")
            .addEventListener("click", async function () {
            await clearUserDataForCautionary();
            var myHeaders = new Headers();
            myHeaders.append("ClientId", "NTk5NDkwMDQ=");
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("AppName", "5PTRADE");
            myHeaders.append("ocp-apim-subscription-key", APP_OCP_APIM_KEY);
            myHeaders.append("Authorization", `Bearer ${localStorage
                .getItem("JWTToken")
                .replaceAll("JwtToken=", "")}`);
            var raw = JSON.stringify({
                ClientCode: "JaSMYKpkOb1EV9LnfYJYbg==",
                MachineID: "BM4653-D-039377.loca",
                ServerIP: "192.168.88.41",
                ClientIP: "192.168.88.41",
            });
            var requestOptions = {
                method: "POST",
                credentials: "include",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };
            fetch(`${APP_BASE_API_URL}tradeapi/Logout`, requestOptions)
                .then((response) => {
                if (response.status === 200) {
                    window.location.replace("https://Invest.5paisa.com/home/logout");
                }
                else {
                    console.error("Logout failed:", error);
                }
            })
                .catch((error) => console.log("error", error));
            document.cookie =
                "5paisacookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
                "JwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            clearSessionData(true);
        });
        document.getElementById("themeTray").addEventListener("click", function () {
            drop.style.display = "none";
            document
                .getElementById("closeThemeIcon")
                .addEventListener("click", function () {
                dialog.close();
            });
            const dialog = document.querySelector("#theme-popup");
            // let currentTheme = themeVal;
            if (themeVal == "Light" || themeVal == "light") {
                radioLight.checked = true;
            }
            else if (themeVal == "Dark" || themeVal == "dark") {
                radioDark.checked = true;
            }
            dialog.showModal((radioLight.onclick = () => {
                radioLight.checked = true;
                radioDark.checked = false;
            }), (radioDark.onclick = () => {
                radioDark.checked = true;
                radioLight.checked = false;
            }), (saveTheme.onclick = () => {
                if (radioLight.checked && themeVal !== "light") {
                    prefChanged = true;
                    themeVal = "light";
                    deleteThemeCookieAndSetNewCookie(themeVal);
                    changeThemeFun(themeVal, tvWidget);
                    optionsChainButton.classList.add("optionsChain");
                    optionsChainButton.classList.remove("optionsChainDark");
                    drop.style.background = "white";
                    drop.style.color = "#131722";
                    document.body.classList.remove("dark-theme");
                    fundsButton.classList.remove("fundsIconDark");
                    popOut.classList.remove("popoutIconDark");
                    fundsButton.classList.add("fundsIcon");
                    marketDepthButton.classList.remove("marketDepthIconDark");
                    marketDepthButton.classList.add("marketDepthIcon");
                    popOut.classList.add("popoutIcon");
                    updateProductsPopupTheme("light");
                }
                else if (radioDark.checked && themeVal !== "dark") {
                    prefChanged = true;
                    themeVal = "dark";
                    deleteThemeCookieAndSetNewCookie(themeVal);
                    changeThemeFun(themeVal, tvWidget);
                    optionsChainButton.classList.add("optionsChainDark");
                    optionsChainButton.classList.remove("optionsChain");
                    drop.style.background = "#1e222d";
                    drop.style.color = "#d1d4dc";
                    document.body.classList.add("dark-theme");
                    fundsButton.classList.add("fundsIconDark");
                    marketDepthButton.classList.add("marketDepthIconDark");
                    marketDepthButton.classList.remove("marketDepthIcon");
                    popOut.classList.add("popoutIconDark");
                    updateProductsPopupTheme("dark");
                }
                preferences = {
                    themeVal,
                    productVal,
                    defaultClose,
                };
                if (prefChanged === true) {
                    setPreferenceApi(preferences, user);
                    prefChanged = false;
                }
                dialog.close();
            }), (cancelTheme.onclick = () => {
                dialog.close();
            }));
        });
        const transactionToggle = document.getElementById("transactionToggle");
        if (localStorage.getItem("TransactionButtonFlag") === "true") {
            transactionToggle.checked = true;
        }
        else {
            transactionToggle.checked = false;
        }
        (_a = document
            .getElementById("transactionTray")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
            var _a, _b;
            const dialog = document.querySelector("#transaction-popup");
            const radioIntradaytrans = document.getElementById("intradaytrans");
            const radioDeliverytrans = document.getElementById("deliverytrans");
            const saveTransaction = document.getElementById("saveTransaction");
            const cancelTransaction = document.getElementById("cancelTransaction");
            const SelectedTransactionType = localStorage.getItem("selectedTransactionType");
            if (SelectedTransactionType == null) {
                radioIntradaytrans.checked = false;
                radioDeliverytrans.checked = true;
            }
            else if (SelectedTransactionType == "Intraday") {
                radioIntradaytrans.checked = true;
                radioDeliverytrans.checked = false;
            }
            else if (SelectedTransactionType == "Delivery") {
                radioIntradaytrans.checked = false;
                radioDeliverytrans.checked = true;
            }
            let previousState = localStorage.getItem("TransactionButtonFlag");
            transactionToggle === null || transactionToggle === void 0 ? void 0 : transactionToggle.addEventListener("change", function () {
                if (transactionToggle.checked) {
                    localStorage.setItem("TransactionButtonFlag", "true");
                    dialog.showModal();
                }
                else {
                    if (previousState) {
                        localStorage.setItem("TransactionButtonFlag", "false");
                        drop.style.display = "none";
                        window.tvWidget.activeChart().clearMarks();
                        setTimeout(() => {
                            window.tvWidget.activeChart().refreshMarks();
                        }, 100);
                    }
                }
                previousState = transactionToggle.checked;
            });
            (_a = document
                .getElementById("closeTransactionIcon")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", function () {
                dialog.close();
            });
            (_b = document
                .getElementById("transactionButton")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", function () {
                if (localStorage.getItem("TransactionButtonFlag") == "true") {
                    dialog.showModal();
                }
            });
            saveTransaction === null || saveTransaction === void 0 ? void 0 : saveTransaction.addEventListener("click", () => {
                if (radioDeliverytrans.checked &&
                    localStorage.getItem("selectedTransactionType") !== "Delivery") {
                    localStorage.setItem("selectedTransactionType", radioDeliverytrans.value);
                }
                else if (radioIntradaytrans.checked &&
                    localStorage.getItem("selectedTransactionType") !== "Intraday") {
                    localStorage.setItem("selectedTransactionType", radioIntradaytrans.value);
                }
                window.tvWidget.activeChart().clearMarks();
                setTimeout(() => {
                    window.tvWidget.activeChart().refreshMarks();
                }, 100);
                drop.style.display = "none";
                dialog.close();
            });
            cancelTransaction === null || cancelTransaction === void 0 ? void 0 : cancelTransaction.addEventListener("click", () => {
                dialog.close();
            });
        });
        document.getElementById("orderTray").addEventListener("click", function () {
            drop.style.display = "none";
            let radioMarket = document.getElementById("market");
            let radioLimit = document.getElementById("limit");
            let radioIntraday = document.getElementById("intraday");
            let radioDelivery = document.getElementById("delivery");
            let saveOrder = document.getElementById("saveOrder");
            document
                .getElementById("closeOrderIcon")
                .addEventListener("click", function () {
                dialog.close();
            });
            const dialog = document.querySelector("#order-popup");
            let currentProd = localStorage.getItem("productVal");
            let currentClose = localStorage.getItem("defaultClose");
            if (currentClose == "Market") {
                radioMarket.checked = true;
                radioLimit.checked = false;
            }
            else if (currentClose == "Limit") {
                radioMarket.checked = false;
                radioLimit.checked = true;
            }
            if (currentProd == "Delivery") {
                radioDelivery.checked = true;
                radioIntraday.checked = false;
            }
            else if (currentProd == "Intraday") {
                radioDelivery.checked = false;
                radioIntraday.checked = true;
            }
            dialog.showModal((radioMarket.onclick = () => {
                radioMarket.checked = true;
                radioLimit.checked = false;
            }), (radioLimit.onclick = () => {
                radioMarket.checked = false;
                radioLimit.checked = true;
            }), (radioDelivery.onclick = () => {
                radioDelivery.checked = true;
                radioIntraday.checked = false;
            }), (radioIntraday.onclick = () => {
                radioDelivery.checked = false;
                radioIntraday.checked = true;
            }), (saveOrder.onclick = () => {
                if (radioMarket.checked &&
                    localStorage.getItem("defaultClose") !== "Market") {
                    prefChanged = true;
                    localStorage.setItem("defaultClose", radioMarket.value);
                    defaultClose = localStorage.getItem("defaultClose");
                }
                else if (radioLimit.checked &&
                    localStorage.getItem("defaultClose") !== "Limit") {
                    prefChanged = true;
                    localStorage.setItem("defaultClose", radioLimit.value);
                    defaultClose = localStorage.getItem("defaultClose");
                }
                if (radioDelivery.checked &&
                    localStorage.getItem("productVal") !== "Delivery") {
                    prefChanged = true;
                    localStorage.setItem("productVal", radioDelivery.value);
                    productVal = localStorage.getItem("productVal");
                }
                else if (radioIntraday.checked &&
                    localStorage.getItem("productVal") !== "Intraday") {
                    prefChanged = true;
                    localStorage.setItem("productVal", radioIntraday.value);
                    productVal = localStorage.getItem("productVal");
                }
                preferences = {
                    themeVal,
                    productVal,
                    defaultClose,
                };
                if (prefChanged === true) {
                    setPreferenceApi(preferences, user);
                    prefChanged = false;
                }
                dialog.close();
            }), (cancelOrder.onclick = () => {
                dialog.close();
            }));
        });
    });
}
fetchAndMergeIndicesOncePerDay();
export function isWebsocketFail() {
    if (sessionStorage.getItem("isConnectionFailed") == "true") {
        if (reqUrl.searchParams.get("isTradeChart") === "true") {
            showMessage("Connection lost. Try refreshing the page!", false, themeVal);
        }
    }
}
if (reqUrl.searchParams.get("isTradeChart") === "true") {
    window.addEventListener("online", () => {
        checkConnectionStatus(themeVal);
    }, { once: false });
    window.addEventListener("offline", () => {
        checkConnectionStatus(themeVal);
    }, { once: false });
}
setInterval(() => {
    if (prefChanged === true) {
        setPreferenceApi(preferences, user);
        prefChanged = false;
    }
}, 15000);
export { ScripInfoDetails, brokerFac };
